
/* §8 ─ Stylesheet: Design-Line „Kellerbuch" ───────────────────── */

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;0,600;1,500&family=Inter:wght@400;500;600&display=swap');

.wl-root {
  --kreide: #FBFAF6;
  --tinte: #1B1914;
  --nebel: #6F6A5E;
  --granat: #722F37;
  --granat-dunkel: #59252B;
  /* Zustimmung/Zugang — Gegenstück zum Granat, gedeckt gehalten,
     damit es neben der Weinfarbe nicht als Signalgrün wirkt. */
  --zugang: #4C6B52;
  --linie: #ECE8DD;
  --linie-stark: #D8D3C4;
  --serif: 'Cormorant Garamond', Georgia, 'Times New Roman', serif;
  --sans: 'Inter', system-ui, -apple-system, sans-serif;

  min-height: 100vh;
  background: var(--kreide);
  color: var(--tinte);
  font-family: var(--sans);
  font-size: 14px;
  line-height: 1.55;
  -webkit-font-smoothing: antialiased;
}
.wl-root *, .wl-root *::before, .wl-root *::after { box-sizing: border-box; }
.wl-root :focus-visible { outline: 2px solid var(--granat); outline-offset: 2px; }
.wl-root .num { font-variant-numeric: tabular-nums; }

.wl-shell { max-width: 1140px; margin: 0 auto; padding: 0 32px 96px; }

/* Kopf & Navigation */
.wl-header {
  display: flex; justify-content: space-between; align-items: flex-end;
  gap: 24px; flex-wrap: wrap;
  padding: 34px 0 18px; border-bottom: 1px solid var(--linie-stark);
}
.wl-marke { display: block; font-family: var(--serif); font-weight: 600; font-size: 30px; line-height: 1; letter-spacing: 0.01em; }
.wl-logo { display: block; flex: none; color: var(--tinte); }
.wl-kopfmarke { display: flex; align-items: center; gap: 13px; }
.wl-unterzeile { display: block; margin-top: 6px; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.2em; color: var(--nebel); }
.wl-nav { display: flex; gap: 28px; }
.wl-nav button {
  background: none; border: none; cursor: pointer; padding: 8px 0 10px;
  font-family: var(--sans); font-size: 11px; font-weight: 500;
  text-transform: uppercase; letter-spacing: 0.15em; color: var(--nebel);
  border-bottom: 1px solid transparent; margin-bottom: -19px;
}
.wl-nav button:hover { color: var(--tinte); }
.wl-nav button.aktiv { color: var(--tinte); border-bottom-color: var(--granat); }

/* Seitenköpfe & Abschnitte */
.wl-seitenkopf { display: flex; justify-content: space-between; align-items: flex-end; gap: 24px; flex-wrap: wrap; margin: 44px 0 22px; }
.wl-titel { font-family: var(--serif); font-weight: 500; font-size: 36px; line-height: 1.08; margin: 0; }
.wl-brotkrume { font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.14em; color: var(--nebel); margin-bottom: 10px; }
.wl-brotkrume .wl-textknopf { font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.14em; color: var(--nebel); border-bottom-color: transparent; }
.wl-brotkrume .wl-textknopf:hover { color: var(--granat); border-bottom-color: rgba(114, 47, 55, 0.35); }
.wl-unterzeile-seite { margin: 8px 0 0; color: var(--nebel); font-size: 13px; }
.wl-aktionen { display: flex; gap: 10px; flex-wrap: wrap; }
.wl-abschnitt { margin-top: 48px; }
.wl-abschnittskopf {
  display: flex; justify-content: space-between; align-items: baseline; gap: 16px; flex-wrap: wrap;
  border-bottom: 1px solid var(--linie-stark); padding-bottom: 10px;
}
.wl-abschnittstitel { font-family: var(--serif); font-weight: 600; font-size: 22px; margin: 0; }
.wl-fliesstext { max-width: 64ch; margin: 4px 0 0; }
.wl-fuss {
  margin-top: 96px; padding-top: 16px; border-top: 1px solid var(--linie);
  font-size: 11px; color: var(--nebel);
  display: flex; justify-content: space-between; gap: 16px; flex-wrap: wrap;
}
.wl-syncstatus { white-space: nowrap; }
.wl-syncstatus.ist-offline { color: var(--granat); }
.wl-syncbereich { display: inline-flex; align-items: center; gap: 8px; }
.wl-adminblock { margin-bottom: 26px; }
.wl-adminTitel {
  font-family: var(--sans); font-size: 11px; text-transform: uppercase; letter-spacing: 0.14em;
  color: var(--nebel); margin: 0 0 10px; padding-bottom: 6px; border-bottom: 1px solid var(--linie);
}
.wl-adminmarke {
  display: inline-block; margin-left: 8px; padding: 1px 6px; border-radius: 2px;
  background: var(--granat); color: var(--kreide); font-family: var(--sans); font-size: 9.5px;
  text-transform: uppercase; letter-spacing: 0.1em; vertical-align: 1px;
}
.wl-refresh { background: none; border: none; cursor: pointer; color: var(--nebel); font-size: 14px; line-height: 1; padding: 2px 4px; border-radius: 2px; }
.wl-refresh:hover { color: var(--granat); }

/* Kennzahlen-Leiste */
.wl-ledger {
  display: flex; gap: 56px; flex-wrap: wrap;
  padding: 20px 0; margin-bottom: 26px;
  border-bottom: 1px solid var(--linie-stark);
}
.wl-kennzahl { display: block; font-family: var(--serif); font-weight: 500; font-size: 32px; line-height: 1.05; }
.wl-jgbestand { display: flex; align-items: baseline; gap: 24px; flex-wrap: wrap; }
.wl-datenliste { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 2px 32px; margin: 0; }
.wl-datenpaar { display: flex; justify-content: space-between; gap: 16px; padding: 10px 0; border-bottom: 1px solid var(--linie); }
.wl-datenpaar dt { color: var(--nebel); font-size: 13px; }
.wl-datenpaar dd { margin: 0; font-size: 13.5px; text-align: right; }
.wl-jahrlinks { display: flex; flex-wrap: wrap; gap: 4px 10px; }
.wl-jahrlink { background: none; border: none; padding: 0; cursor: pointer; color: var(--granat); font-family: var(--serif); border-bottom: 1px solid rgba(114,47,55,0.28); }
.wl-jahrlink:hover { border-bottom-color: var(--granat); }
.wl-kennname { display: block; margin-top: 5px; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.14em; color: var(--nebel); }

/* Zurück-Leiste */
.wl-zurueck { margin: 26px 0 -8px; }
.wl-zurueckknopf {
  background: none; border: none; padding: 0; cursor: pointer;
  font-family: var(--sans); font-size: 11px; font-weight: 500;
  text-transform: uppercase; letter-spacing: 0.14em; color: var(--nebel);
}
.wl-zurueckknopf:hover { color: var(--granat); }
.wl-zurueckknopf span { font-size: 14px; }

/* Werkzeugleiste: Suche, Filter-Umschalter, Bestand, Primäraktion */
.wl-werkzeuge-block { margin: 30px 0 20px; }
.wl-werkzeuge {
  display: flex; justify-content: space-between; align-items: center;
  gap: 16px; flex-wrap: wrap;
}
/* Suchfeld und die beiden Symbolknöpfe bleiben IMMER in einer Zeile.
   Statt umzubrechen schrumpft das Eingabefeld — die Knöpfe sind
   34 px breit und nicht sinnvoll kleiner zu machen, das Feld schon.
   Deshalb flex-wrap: nowrap und min-width: 0 an der Huelle: Ohne
   Letzteres weigert sich ein Flex-Element, unter seine Inhaltsbreite
   zu gehen, und schiebt die Knöpfe hinaus. */
.wl-werkzeuge-links { display: flex; gap: 8px; align-items: center; flex-wrap: nowrap; min-width: 0; }
.wl-werkzeuge .wl-btn { height: 36px; }
.wl-suche { width: 180px; max-width: 100%; height: 36px; padding: 0 12px; }

/* Suchfeld mit Löschkreuz */
/* Schrumpfen ja, wachsen nein: flex 0 1 auto haelt die 180 px
   des Feldes, gibt sie aber her, wenn der Platz nicht reicht. */
.wl-suchfeld { position: relative; display: inline-flex; align-items: center; min-width: 0; flex: 0 1 auto; }
.wl-suchfeld .wl-suche { min-width: 0; width: 100%; }
.wl-suchfeld .wl-suche { padding-right: 30px; }
.wl-suchleeren {
  position: absolute; right: 6px; top: 50%; transform: translateY(-50%);
  width: 20px; height: 20px; padding: 0; line-height: 1;
  border: none; border-radius: 50%; background: none; cursor: pointer;
  color: var(--nebel); font-size: 16px;
}
.wl-suchleeren:hover { color: var(--granat); background: rgba(114, 47, 55, 0.08); }

/* Filter und Sortierung als Symbole */
.wl-werkzeugknopf {
  position: relative; display: inline-flex; align-items: center; justify-content: center;
  width: 34px; height: 34px; flex: none;
  border: 1px solid var(--linie-stark); border-radius: 4px; background: none;
  cursor: pointer; color: var(--nebel);
}
.wl-werkzeugknopf:hover { color: var(--granat); border-color: var(--granat); }
.wl-werkzeugknopf.ist-offen { background: rgba(114, 47, 55, 0.07); color: var(--granat); border-color: var(--granat); }
.wl-werkzeugknopf.ist-aktiv { color: var(--granat); border-color: var(--granat); }
.wl-werkzeugknopf .wl-filterpunkt { position: absolute; top: 4px; right: 4px; }

/* Umfang der Listen im Hauptmenü */
.wl-hm-schemawahl {
  width: 100%; margin-top: 4px; padding: 6px 8px;
  border: 1px solid var(--linie-stark); border-radius: 3px; background: none;
  font-family: var(--sans); font-size: 12.5px; color: var(--tinte);
}
.wl-hm-teilen { padding: 8px 0 0; border-bottom: none; }

.wl-hm-sicht { display: flex; flex-direction: column; gap: 2px; padding: 8px 16px 10px; }
.wl-hm-sichtpunkt {
  text-align: left; padding: 7px 10px; border: none; background: none; cursor: pointer;
  border-radius: 3px; font-family: var(--sans); font-size: 12.5px; color: var(--tinte);
}
.wl-hm-sichtpunkt:hover { background: rgba(114, 47, 55, 0.06); color: var(--granat); }
.wl-hm-sichtpunkt.aktiv { background: var(--granat); color: #fff; }

/* Hier stand der Umschalter „Mein Keller / Alle“ als Pille. Er ist
   in die Sichtwahl im Hauptmenü gewandert — die Regeln blieben aber
   stehen und trafen weiter .wl-quelle, die Bildunterschrift unter
   dem Witterungsdiagramm. Die bekam dadurch einen abgerundeten
   Rahmen und 12-px-Schrift und war auf dem Telefon kaum lesbar. */

/* Eintrag stammt nur aus dem Katalog, nicht aus dem eigenen Keller */
.wl-kritikmehr { margin-top: 10px; }

.wl-katalogmarke {
  margin-left: 7px; font-size: 9.5px; text-transform: uppercase;
  letter-spacing: 0.09em; color: var(--nebel);
  border: 1px solid var(--linie-stark); border-radius: 999px; padding: 1px 6px;
}

.wl-filterknopf {
  height: 36px; padding-top: 0; padding-bottom: 0;
  display: inline-flex; align-items: center;
}
/* Sortier-Auswahl in der Werkzeugleiste */
.wl-sortauswahl { width: auto; min-width: 200px; }
.wl-filterknopf {
  position: relative; display: inline-flex; align-items: center; gap: 6px;
  font-family: var(--sans); font-size: 11px; font-weight: 500;
  text-transform: uppercase; letter-spacing: 0.12em;
  padding: 9px 16px; cursor: pointer; border-radius: 1px;
  border: 1px solid var(--linie-stark); background: transparent; color: var(--nebel);
}
.wl-filterknopf:hover { border-color: var(--granat); color: var(--granat); }
.wl-filterknopf.ist-offen { border-color: var(--tinte); color: var(--tinte); }
.wl-filterknopf.ist-aktiv { color: var(--granat); border-color: var(--granat); }
.wl-filterpunkt { width: 6px; height: 6px; border-radius: 50%; background: var(--granat); display: inline-block; }
.wl-filterleiste {
  display: flex; gap: 12px; align-items: center; flex-wrap: wrap;
  margin-top: 14px; padding: 16px 18px;
  background: rgba(114, 47, 55, 0.02); border: 1px solid var(--linie);
}
.wl-filterleiste .wl-eingabe { width: auto; min-width: 150px; max-width: 210px; }

/* Mehrfachauswahl in Filterleisten (ui/mehrfachauswahl.jsx). Der
   Knopf trägt .wl-eingabe und sieht damit aus wie die Auswahlfelder
   daneben; die Breitenregel der Filterleiste greift auf die Hülle,
   der Knopf füllt sie. */
.wl-mehrfach { position: relative; display: inline-block; }
.wl-filterleiste .wl-mehrfach { min-width: 150px; max-width: 210px; }
.wl-filterleiste .wl-mehrfach .wl-eingabe { width: 100%; min-width: 0; max-width: none; }
.wl-mehrfach-knopf {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
  text-align: left; cursor: pointer; line-height: inherit;
}
.wl-mehrfach-knopf.ist-aktiv { border-color: var(--granat); color: var(--granat); }
.wl-mehrfach-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; }
.wl-mehrfach-pfeil { flex: none; font-size: 10px; color: var(--nebel); }
.wl-mehrfach-liste {
  position: absolute; z-index: 70; top: calc(100% + 2px); left: 0;
  min-width: 100%; width: max-content; max-width: min(320px, calc(100vw - 32px));
  max-height: 300px; overflow-y: auto; padding: 4px 0;
  background: var(--kreide); border: 1px solid var(--linie-stark);
  box-shadow: 0 12px 30px rgba(20, 18, 12, 0.18);
}
.wl-mehrfach-suchzeile { padding: 4px 8px 6px; }
.wl-mehrfach-liste .wl-mehrfach-suche { display: block; width: 100%; min-width: 0; max-width: none; margin: 0; }
.wl-mehrfach-punkt {
  display: flex; align-items: center; gap: 9px; padding: 7px 12px;
  font-size: 13px; color: var(--tinte); cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
/* Nur mit echtem Zeiger — auf dem Telefon bliebe der Ton an der
   zuletzt angetippten Zeile hängen. */
@media (hover: hover) { .wl-mehrfach-punkt:hover { background: rgba(114, 47, 55, 0.06); } }
.wl-mehrfach-punkt input { flex: none; width: 14px; height: 14px; margin: 0; accent-color: var(--granat); }
.wl-mehrfach-punkt span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wl-mehrfach-punkt.ist-gewaehlt span { color: var(--granat); }
.wl-mehrfach-punkt.ist-alle { border-bottom: 1px solid var(--linie); margin-bottom: 2px; color: var(--nebel); }
.wl-mehrfach-leer { padding: 8px 12px; font-size: 12.5px; color: var(--nebel); }
/* Geteilte Ansichten: so klein wie die übrigen Felder dort. */
.wl-mehrfach.ist-kompakt .wl-mehrfach-knopf { width: auto; min-width: 130px; max-width: 200px; font-size: 12.5px; padding: 5px 8px; }
.wl-check { display: inline-flex; align-items: center; gap: 8px; font-size: 12px; color: var(--nebel); cursor: pointer; white-space: nowrap; }
.wl-nvschalter { margin-top: 8px; }
/* Textzellen in Tabellen stets linksbündig (Zahlenspalten bleiben unberührt) */
.wl-tabelle td, .wl-tabelle th { text-align: left; }
.wl-tabelle .wl-rechts { text-align: right; }
.wl-check input { accent-color: var(--granat); width: 14px; height: 14px; }

/* Tabellen */
.wl-scroll { overflow-x: auto; }
.wl-tabelle { width: 100%; border-collapse: collapse; }
.wl-tabelle th {
  text-align: left; font-size: 10.5px; font-weight: 500;
  text-transform: uppercase; letter-spacing: 0.12em; color: var(--nebel);
  padding: 10px 14px 8px; border-bottom: 1px solid var(--linie-stark); white-space: nowrap;
}
.wl-tabelle td { padding: 13px 14px; border-bottom: 1px solid var(--linie); vertical-align: middle; font-size: 13.5px; }
.wl-tabelle tbody tr:hover td { background: rgba(114, 47, 55, 0.03); }
.wl-tabelle .wl-rechts { text-align: right; white-space: nowrap; }
.wl-zeilentitel {
  font-weight: 600; display: block; text-align: left;
  background: none; border: none; padding: 0; cursor: pointer;
  font-family: var(--sans); font-size: 13.5px; color: var(--tinte);
}
button.wl-zeilentitel:hover { color: var(--granat); }
.wl-nebenzeile { display: block; font-size: 11.5px; color: var(--nebel); margin-top: 2px; max-width: 420px; }
.wl-nebenlink {
  display: block; background: none; border: none; padding: 0; margin-top: 2px;
  cursor: pointer; text-align: left; font-family: var(--sans);
  font-size: 11.5px; color: var(--nebel);
}
.wl-nebenlink:hover { color: var(--granat); }
.wl-jahrnum { font-family: var(--serif); font-weight: 600; font-size: 19px; }
.wl-kritikzelle { white-space: nowrap; }
.wl-kritikzelle .wl-textknopf { margin-right: 10px; }
.wl-notiz { max-width: 300px; color: var(--nebel); }
.wl-bewertung { display: block; font-weight: 600; }

/* Typ-Punkt, Balken, Bestand */
.wl-typ { display: inline-flex; align-items: center; gap: 7px; white-space: nowrap; }
.wl-typ i { width: 9px; height: 9px; border-radius: 50%; display: inline-block; flex: none; }
.wl-balken { display: block; width: 120px; height: 2px; background: var(--linie-stark); margin-top: 6px; }
.wl-balken i { display: block; height: 100%; background: var(--granat); }
.wl-bestandanzeige { display: inline-block; }
.wl-bestandzahl { font-weight: 600; font-size: 13.5px; }
.wl-bestandanzeige .wl-nebenzeile { white-space: nowrap; }

/* Dreipunkt-Zeilenmenü */
.wl-menue { display: inline-block; }
.wl-menueknopf {
  width: 30px; height: 27px; border: 1px solid var(--linie-stark); background: #FFFFFF;
  cursor: pointer; font-size: 16px; line-height: 1; color: var(--nebel);
  font-family: var(--sans); border-radius: 1px;
}
.wl-menueknopf:hover, .wl-menueknopf[aria-expanded="true"] { color: var(--granat); border-color: var(--granat); }
.wl-menueliste {
  position: fixed; z-index: 60; min-width: 200px;
  display: flex; flex-direction: column; padding: 6px 0;
  background: var(--kreide); border: 1px solid var(--linie-stark);
  box-shadow: 0 14px 36px rgba(20, 18, 12, 0.18);
  max-height: 80vh; overflow-y: auto;
}
.wl-menuepunkt {
  background: none; border: none; cursor: pointer; text-align: left;
  padding: 8px 16px; font-family: var(--sans); font-size: 12.5px; color: var(--tinte);
}
.wl-menuepunkt:hover { background: rgba(114, 47, 55, 0.05); }
.wl-menuepunkt.ist-gefahr { color: var(--granat); }
span.wl-menuepunkt.ist-inaktiv { opacity: 0.4; cursor: default; }
span.wl-menuepunkt.ist-inaktiv:hover { background: none; }

/* Buttons */
.wl-btn {
  font-family: var(--sans); font-size: 11px; font-weight: 500;
  text-transform: uppercase; letter-spacing: 0.12em;
  padding: 9px 16px; cursor: pointer; border-radius: 1px;
  border: 1px solid var(--tinte); background: transparent; color: var(--tinte);
}
.wl-btn:hover:not(:disabled) { border-color: var(--granat); color: var(--granat); }
.wl-btn:disabled { opacity: 0.45; cursor: default; }
.wl-btn--voll { background: var(--granat); border-color: var(--granat); color: #FDFCF8; }
.wl-btn--voll:hover:not(:disabled) { background: var(--granat-dunkel); border-color: var(--granat-dunkel); color: #FDFCF8; }
.wl-btn--ghost { border-color: var(--linie-stark); color: var(--nebel); }
.wl-btn--gefahr { border-color: var(--granat); color: var(--granat); }
.wl-btn--gefahrScharf { background: var(--granat); border-color: var(--granat); color: #FDFCF8; }
.wl-btn--gefahrScharf:hover { background: var(--granat-dunkel); color: #FDFCF8; }
.wl-textknopf {
  background: none; border: none; padding: 0; cursor: pointer;
  font-family: var(--sans); font-size: 12.5px; color: var(--granat);
  border-bottom: 1px solid rgba(114, 47, 55, 0.35);
}
.wl-textknopf:hover { border-bottom-color: var(--granat); }
.wl-textknopf.ist-scharf { font-weight: 600; }
.wl-textknopf.ist-dezent { color: var(--nebel); border-bottom-color: transparent; }
.wl-textknopf.ist-dezent:hover { color: var(--granat); border-bottom-color: rgba(114, 47, 55, 0.35); }
span.wl-textknopf.ist-inaktiv { opacity: 0.4; border-bottom: none; cursor: default; }

/* Formulare & Modal */
.wl-eingabe {
  width: 100%; padding: 9px 11px; font-family: var(--sans); font-size: 13.5px;
  border: 1px solid var(--linie-stark); background: #FFFFFF;
  color: var(--tinte); border-radius: 1px;
}
.wl-eingabe:focus { outline: 1.5px solid var(--granat); outline-offset: 0; }
textarea.wl-eingabe { resize: vertical; }

/* Vergleich (Weine, Jahre) */
.wl-vergleichsleiste { margin: 18px 0 -6px; }
.wl-vergleichsfeld { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.wl-vergleichsfeld .wl-suchauswahl { min-width: 260px; flex: 0 1 320px; }
.wl-vergleichsfeld .wl-feldname { flex: none; }
.wl-tabelle td.ist-vergleich { background: rgba(185, 161, 92, 0.09); }
.wl-diff-plus { color: var(--granat); }
.wl-diff-minus { color: #4C6B84; }

/* Durchsuchbare Auswahl */
.wl-suchauswahl { position: relative; }
.wl-suchfeld { padding-right: 28px; text-overflow: ellipsis; cursor: pointer; }
.wl-suchfeld:focus { cursor: text; }
.wl-suchpfeil { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: var(--nebel); font-size: 10px; pointer-events: none; }
.wl-suchliste {
  position: absolute; z-index: 70; top: calc(100% + 2px); left: 0; right: 0;
  margin: 0; padding: 4px 0; list-style: none; max-height: 240px; overflow-y: auto;
  background: var(--kreide); border: 1px solid var(--linie-stark);
  box-shadow: 0 12px 30px rgba(20, 18, 12, 0.18);
}
.wl-suchopt {
  display: flex; justify-content: space-between; align-items: baseline; gap: 12px;
  padding: 8px 12px; cursor: pointer; font-size: 13px;
}
.wl-suchopt.ist-aktiv { background: rgba(114, 47, 55, 0.08); }
.wl-suchopt.ist-gewaehlt .wl-suchopt-label { font-weight: 600; color: var(--granat); }
.wl-suchopt.ist-betont .wl-suchopt-label { color: var(--granat); }
.wl-suchopt-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wl-suchopt-neben { flex: none; font-size: 11px; color: var(--nebel); }
.wl-suchleer { padding: 10px 12px; font-size: 12.5px; color: var(--nebel); }
.wl-feld { display: flex; flex-direction: column; gap: 6px; }
.wl-feldname { font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--nebel); }
.wl-formgitter { display: grid; grid-template-columns: 1fr 1fr; gap: 16px 20px; }
.wl-formgitter .voll { grid-column: 1 / -1; }
.wl-subform { border: 1px solid var(--linie-stark); padding: 16px 18px 18px; background: rgba(114, 47, 55, 0.02); }
.wl-subformtitel { display: block; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.14em; color: var(--granat); margin-bottom: 12px; }
.wl-fehler { color: var(--granat); font-size: 12.5px; margin: 14px 0 0; }
.wl-hinweis { color: var(--nebel); font-size: 13px; margin: 0 0 18px; }
.wl-modalfuss { display: flex; justify-content: flex-end; align-items: center; margin-top: 26px; }
.wl-modalfuss.hat-links { justify-content: space-between; }
.wl-modalfuss-rechts { display: flex; gap: 10px; }
.wl-schleier {
  position: fixed; inset: 0; z-index: 50;
  background: rgba(24, 22, 17, 0.44);
  display: flex; align-items: flex-start; justify-content: center;
  padding: 9vh 20px 20px; overflow-y: auto;
  animation: wl-einblenden 0.14s ease-out;
}
.wl-modal:focus { outline: none; }
.wl-modal {
  width: 100%; max-width: 640px;
  background: var(--kreide); border: 1px solid var(--linie-stark);
  padding: 26px 32px 30px; box-shadow: 0 24px 64px rgba(20, 18, 12, 0.22);
}
.wl-modalkopf { display: flex; justify-content: space-between; align-items: baseline; gap: 16px; margin-bottom: 22px; }
.wl-modalkopf h2 { font-family: var(--serif); font-weight: 600; font-size: 24px; margin: 0; }
.wl-schliessen { background: none; border: none; cursor: pointer; font-size: 22px; line-height: 1; color: var(--nebel); padding: 2px 6px; flex: none; }
.wl-schliessen:hover { color: var(--tinte); }
@keyframes wl-einblenden { from { opacity: 0; } to { opacity: 1; } }

/* Regionen- & Länderraster */
.wl-kartenraster {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1px; background: var(--linie-stark); border: 1px solid var(--linie-stark);
}
.wl-regionskarte {
  display: flex; flex-direction: column; align-items: flex-start; gap: 8px;
  background: var(--kreide); padding: 22px 24px 20px;
  border: none; text-align: left; font-family: var(--sans); color: var(--tinte);
}
.wl-regionskarte.ist-klickbar { cursor: pointer; }
.wl-regionskarte.ist-klickbar:hover { background: #F5F2E9; }
.wl-eyebrow { font-size: 10px; text-transform: uppercase; letter-spacing: 0.16em; color: var(--nebel); }
.wl-regionsname { font-family: var(--serif); font-weight: 600; font-size: 23px; line-height: 1.1; }
button.wl-regionsname.ist-link { background: none; border: none; padding: 0; cursor: pointer; text-align: left; color: var(--tinte); }
button.wl-regionsname.ist-link:hover { color: var(--granat); }
.wl-regionstext { font-size: 12.5px; line-height: 1.55; color: var(--nebel); }
.wl-regionsfuss { font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em; color: var(--granat); margin-top: 4px; }
.wl-kartenaktionen { margin-top: 8px; padding-top: 10px; border-top: 1px solid var(--linie); align-self: stretch; }
.wl-kartenaktionen .wl-textknopf { margin-right: 12px; }

/* Regionsdetail: Karte & Fakten */
.wl-zweispalt { display: grid; grid-template-columns: 1.05fr 0.95fr; gap: 36px; align-items: start; }
.wl-karte { border: 1px solid var(--linie-stark); background: #EFEDE6; }
.wl-karte iframe { display: block; width: 100%; height: 300px; border: 0; filter: grayscale(1) contrast(0.92) opacity(0.95); }
.wl-kartenlegende { display: block; padding: 8px 12px; font-size: 10.5px; letter-spacing: 0.06em; color: var(--nebel); border-top: 1px solid var(--linie-stark); }
.wl-fakten { display: grid; grid-template-columns: auto 1fr; gap: 8px 20px; margin: 20px 0 0; font-size: 13px; }
.wl-fakten dt { font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--nebel); padding-top: 2px; }
.wl-fakten dd { margin: 0; }

/* Witterungsprofil */
/* flex-wrap: Auswahl, „Witterung abrufen“ und „Klimareihe aktualisieren“
   zusammen sind auf 390 px breiter als die Zeile — das ist ab dem 6.11.
   der Normalfall, bis die Reihe das neue Jahr hat. */
.wl-witterungssteuerung { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; }
.wl-witterungssteuerung .wl-eingabe { width: 110px; }
.wl-kpis {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1px; background: var(--linie-stark); border: 1px solid var(--linie-stark); margin: 22px 0;
}
.wl-kpi { background: var(--kreide); padding: 16px 18px 14px; }
.wl-kpiwert { display: block; font-family: var(--serif); font-weight: 500; font-size: 26px; line-height: 1.05; }
.wl-kpiname { display: block; margin-top: 5px; font-size: 10px; text-transform: uppercase; letter-spacing: 0.1em; color: var(--nebel); }
.wl-diagramm { margin-top: 6px; }
/* Bildunterschrift unter Diagramm und Tabelle: erklärt Zeitraum,
   Achsen und Quelle. 11 px waren auf dem Telefon zu klein; kein
   Rahmen, keine Rundung — es ist Fließtext, kein Kasten. */
.wl-quelle {
  display: block; font-size: 12.5px; line-height: 1.55;
  color: var(--nebel); margin: 12px 0 0; border: none; border-radius: 0;
  max-width: 70ch;
}
/* Stilprofil */
.wl-stil { margin-top: 34px; }
.wl-stil-achsen { list-style: none; margin: 12px 0 0; padding: 0; }
.wl-stil-achse {
  display: grid; grid-template-columns: minmax(120px, 1fr) minmax(90px, 2fr) minmax(90px, 1fr);
  align-items: center; gap: 12px; padding: 7px 0; border-bottom: 1px solid var(--linie);
}
.wl-stil-label { font-size: 12.5px; color: var(--nebel); }
.wl-stil-skala { position: relative; height: 6px; background: var(--linie); }
.wl-stil-marke {
  /* Die Marke bleibt ganz im Balken: Bei 100 % stand sie vorher
     jenseits des rechten Rands und war kaum zu sehen. */
  position: absolute; top: -4px; width: 3px; height: 14px;
  left: calc(var(--lage, 0.5) * (100% - 3px));
  background: var(--tinte);
}
.wl-stil-achse.ist-0 .wl-stil-marke, .wl-stil-achse.ist-4 .wl-stil-marke { background: var(--granat); }
.wl-stil-wort { font-size: 13px; }
.wl-stil-achse.ist-0 .wl-stil-wort, .wl-stil-achse.ist-4 .wl-stil-wort { color: var(--granat); font-weight: 500; }
.wl-stil-merkmale { margin: 14px 0 0; padding-left: 18px; font-size: 13.5px; line-height: 1.55; }
.wl-stil-lese { margin: 10px 0 0; font-size: 12.5px; color: var(--nebel); }
/* Hinweise zur Klimareihe: fehlendes Jahr unter der Vergleichsleiste
   (die hat unten -6px), vorläufiger Reiferegen unter dem Reifetermin. */
.wl-witterungshinweis { margin: 18px 0 0; }
.wl-stil .wl-witterungshinweis { margin: 6px 0 0; font-size: 12.5px; }
.wl-stil-merkmale li { margin-bottom: 4px; }
.wl-stil-merkmale li:first-child { font-weight: 500; }
@media (max-width: 760px) {
  .wl-stil-achse { grid-template-columns: 1fr 1fr; }
  .wl-stil-skala { grid-column: 1 / -1; order: 3; }
}

/* Ähnliche Jahrgänge */
.wl-aehnlich { margin-top: 34px; }
.wl-aehnlich-liste { list-style: none; margin: 12px 0 0; padding: 0; }
.wl-aehnlich-eintrag {
  display: flex; align-items: baseline; gap: 12px; flex-wrap: wrap;
  padding: 9px 0; border-bottom: 1px solid var(--linie);
}
.wl-aehnlich-jahr { font-size: 17px; font-weight: 500; min-width: 3.4em; }
.wl-aehnlich-stufe {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.09em;
  color: var(--nebel); border: 1px solid var(--linie-stark);
  border-radius: 999px; padding: 2px 9px; white-space: nowrap;
}
.wl-aehnlich-eintrag.ist-sehr .wl-aehnlich-stufe { color: var(--granat); border-color: var(--granat); }
.wl-aehnlich-details { font-size: 12.5px; color: var(--nebel); }

.wl-mittelwerte { margin-top: 40px; }
.wl-mittelkopf {
  display: flex; justify-content: space-between; align-items: baseline;
  gap: 16px; flex-wrap: wrap;
  border-bottom: 1px solid var(--linie-stark); padding-bottom: 8px;
}
.wl-mitteltitel { font-family: var(--serif); font-weight: 600; font-size: 19px; margin: 0; }
.wl-mittelhinweis { margin-top: 14px; font-size: 12.5px; line-height: 1.55; max-width: 70ch; }
.wl-tabelle--kompakt td, .wl-tabelle--kompakt th { padding: 10px 14px; }
.wl-tabelle--kompakt td.num { font-weight: 500; }

/* Anmeldung & Konto */
.wl-anmeldung { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; }
.wl-anmeldekarte {
  width: 100%; max-width: 400px;
  background: var(--kreide); border: 1px solid var(--linie-stark);
  padding: 38px 38px 32px; display: flex; flex-direction: column;
}
.wl-anmeldekarte .wl-marke { text-align: center; }
.wl-anmeldelogo { margin: 0 auto 12px; }
.wl-anmeldekarte .wl-unterzeile { text-align: center; margin-bottom: 28px; }
.wl-anmeldewechsel { display: flex; justify-content: center; gap: 28px; border-bottom: 1px solid var(--linie-stark); margin-bottom: 24px; }
.wl-anmeldewechsel button {
  background: none; border: none; cursor: pointer; padding: 0 2px 10px;
  font-family: var(--sans); font-size: 11px; font-weight: 500;
  text-transform: uppercase; letter-spacing: 0.14em; color: var(--nebel);
  border-bottom: 1px solid transparent; margin-bottom: -1px;
}
.wl-anmeldewechsel button:hover { color: var(--tinte); }
.wl-anmeldewechsel button.aktiv { color: var(--tinte); border-bottom-color: var(--granat); }
.wl-anmeldefelder { display: flex; flex-direction: column; gap: 14px; }
.wl-anmeldeknopf { margin-top: 24px; width: 100%; }
.wl-anmeldehinweis { margin: 16px 0 0; font-size: 11.5px; line-height: 1.5; color: var(--nebel); text-align: center; }
/* Hauptmenü */
.wl-hauptmenue { position: relative; }
.wl-hm-knopf {
  width: 34px; height: 34px; flex: none; margin-left: -6px;
  display: flex; align-items: center; justify-content: center;
  border: none; background: transparent; color: var(--tinte);
  cursor: pointer;
}
.wl-hm-knopf:hover, .wl-hm-knopf.ist-offen { color: var(--granat); }
.wl-hm-icon { display: flex; flex-direction: column; gap: 4.5px; }
.wl-hm-icon i { display: block; width: 20px; height: 2px; background: currentColor; border-radius: 1px; }
.wl-hm-panel {
  position: absolute; top: calc(100% + 10px); left: 0; z-index: 60;
  min-width: 232px; background: var(--kreide); border: 1px solid var(--linie-stark);
  box-shadow: 0 10px 26px rgba(27, 25, 20, 0.09); padding: 4px 0;
}
.wl-hm-konto { display: flex; flex-direction: column; gap: 2px; padding: 12px 16px; border-bottom: 1px solid var(--linie); }
.wl-hm-label { font-size: 9.5px; text-transform: uppercase; letter-spacing: 0.14em; color: var(--nebel); }
.wl-hm-name { font-family: var(--serif); font-weight: 600; font-size: 17px; }
.wl-hm-name.ist-offline { color: var(--granat); }
.wl-hm-schalter {
  display: flex; align-items: center; gap: 9px; padding: 12px 16px;
  font-size: 12.5px; cursor: pointer; border-bottom: 1px solid var(--linie);
}
.wl-hm-schalter input { accent-color: var(--granat); }
.wl-hm-punkt {
  display: block; width: 100%; text-align: left; padding: 12px 16px;
  background: none; border: none; cursor: pointer;
  font-family: var(--sans); font-size: 12.5px; color: var(--tinte);
}
.wl-hm-punkt:hover { background: rgba(114, 47, 55, 0.06); color: var(--granat); }
.wl-hm-punkt--gefahr { border-top: 1px solid var(--linie); }
.wl-loeschopt { margin: 4px 0 2px; }
.wl-hm-trenner { height: 1px; background: var(--linie); margin: 4px 0; }
.wl-hm-punkt--gefahr { border-top: none; }

/* Import/Export */
.wl-impex-toast {
  position: fixed; left: 50%; bottom: 24px; transform: translateX(-50%);
  z-index: 200; display: flex; align-items: center; gap: 12px;
  background: var(--tinte); color: var(--kreide);
  padding: 12px 18px; border-radius: 2px; font-size: 13px;
  box-shadow: 0 6px 24px rgba(27, 25, 20, 0.28); max-width: 88vw;
}
.wl-impex-toast.ist-fehler { background: var(--granat); }
.wl-impex-schliessen { background: none; border: none; color: inherit; font-size: 18px; line-height: 1; cursor: pointer; padding: 0 2px; }
.wl-importwarnung { margin-top: 18px; }
.wl-importwarnung ul { margin: 8px 0 0; padding-left: 18px; }
.wl-importwarnung li { font-size: 12.5px; color: var(--nebel); margin-bottom: 4px; }

/* Wetterdaten laden */
.wl-wetterwahl { display: flex; flex-direction: column; gap: 10px; margin: 18px 0 4px; }
.wl-wetteropt {
  display: flex; flex-direction: column; gap: 3px; text-align: left; cursor: pointer;
  background: none; border: 1px solid var(--linie-stark); border-radius: 2px; padding: 13px 16px;
  font-family: var(--sans); transition: border-color 0.12s, background 0.12s;
}
.wl-wetteropt:hover { border-color: var(--granat); background: rgba(114, 47, 55, 0.04); }
.wl-wetteropt-titel { font-size: 13.5px; font-weight: 600; color: var(--tinte); }
.wl-wetteropt-text { font-size: 12px; color: var(--nebel); }
.wl-wetterbalken { height: 8px; background: var(--linie); border-radius: 2px; overflow: hidden; margin: 16px 0 8px; }
.wl-wetterbalken-fill { height: 100%; background: var(--granat); transition: width 0.2s ease; }
.wl-wetterfortschritt { font-size: 12px; color: var(--nebel); margin: 0; }
.wl-wetterwarten { font-size: 12.5px; color: var(--tinte); margin: 10px 0 0; }
.wl-wetterabbruch { border-left: 2px solid var(--granat); padding: 4px 0 4px 12px; margin: 12px 0 14px; }
.wl-wetterabbruch p { margin: 0 0 6px; font-size: 13px; }
.wl-wetterabbruch p:last-child { margin-bottom: 0; color: var(--nebel); }
.wl-favorit { color: var(--gold, #B9A15C); margin-left: 7px; font-size: 0.85em; }
/* Info: Kontakt und aufklappbare Einführung. */
.wl-info { display: flex; flex-direction: column; gap: 12px; }
.wl-info-kontakt { display: flex; flex-direction: column; gap: 6px; }
.wl-info-mail { font-family: var(--serif); font-size: 17px; color: var(--granat); text-decoration: none; align-self: flex-start; border-bottom: 1px solid var(--linie); padding-bottom: 1px; }
.wl-info-mail:hover { border-bottom-color: var(--granat); }
.wl-info-liste { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 6px; }
.wl-info-abschnitt { border: 1px solid var(--linie); border-radius: 4px; }
.wl-info-kopf { display: flex; align-items: baseline; gap: 8px; width: 100%; background: none; border: none; padding: 10px 12px; font: inherit; color: inherit; text-align: left; cursor: pointer; }
.wl-info-kopf:hover .wl-info-titel { color: var(--granat); }
.wl-info-titel { font-family: var(--serif); font-weight: 600; font-size: 15px; }
.wl-info-inhalt { padding: 0 12px 12px 12px; }
.wl-info-punkte { margin: 10px 0 0; }
.wl-info-punkt { margin-bottom: 8px; }
.wl-info-punkt dt { font-weight: 600; font-size: 13px; }
.wl-info-punkt dd { margin: 1px 0 0; font-size: 13px; color: var(--nebel); max-width: 64ch; }

/* Eigenes Label am Wein — dezent, aber als Einordnung erkennbar. */
.wl-weinlabel { border: 1px solid var(--linie); border-radius: 999px; padding: 1px 8px; font-size: 0.85em; }
.wl-oeff-label { border: 1px solid var(--linie); border-radius: 999px; padding: 0 8px; }
.wl-favorit--titel { font-size: 0.6em; vertical-align: 0.15em; }

/* Etikettenfotos */
.wl-foto { display: block; width: 100%; height: 100%; object-fit: cover; }
.wl-fotoplatz {
  display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;
  background: rgba(27, 25, 20, 0.04); color: var(--nebel); font-size: 11px; text-align: center; padding: 6px;
}
.wl-jgkopf { display: flex; justify-content: space-between; align-items: flex-start; gap: 28px; flex-wrap: wrap; }
.wl-etikett { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
.wl-etikettbild {
  width: 108px; height: 144px; padding: 0; overflow: hidden; cursor: zoom-in;
  background: none; border: 1px solid var(--linie-stark);
}
.wl-etikettbild:hover { border-color: var(--granat); }
.wl-etikettaktionen { display: flex; gap: 12px; }
.wl-fotolupe {
  position: fixed; inset: 0; z-index: 90; background: rgba(24, 22, 17, 0.82);
  display: flex; align-items: center; justify-content: center; padding: 5vh 20px; cursor: zoom-out;
  animation: wl-einblenden 0.14s ease-out;
}
.wl-fotolupe .wl-foto.ist-gross { width: auto; height: auto; max-width: 92vw; max-height: 90vh; object-fit: contain; }
.wl-weinkopf { display: flex; align-items: flex-start; gap: 20px; margin-top: 14px; flex-wrap: wrap; }
.wl-weinfoto {
  flex: none; width: 84px; height: 112px; padding: 0; overflow: hidden;
  background: none; border: 1px solid var(--linie-stark); cursor: zoom-in;
}
.wl-weinfoto:hover { border-color: var(--granat); }
/* Rundum-Etikett im Weinkopf: ohne Rahmen, auf der Seite */
.wl-weinrundum { position: relative; flex: none; width: 84px; height: 172px; }
.wl-bodenzeile { margin: 0; font-size: 13.5px; max-width: 72ch; display: flex; gap: 12px; align-items: baseline; }
.wl-bodenzeile .wl-feldname { flex: none; }

/* Appellations-Filter (Chips) */
.wl-appchips { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 20px; }
.wl-appchip {
  font-family: var(--sans); font-size: 11px; letter-spacing: 0.04em;
  padding: 6px 13px; cursor: pointer; border-radius: 1px;
  border: 1px solid var(--linie-stark); background: transparent; color: var(--nebel);
}
.wl-appchip:hover { border-color: var(--tinte); color: var(--tinte); }
.wl-appchip.ist-aktiv { border-color: var(--granat); background: var(--granat); color: #FDFCF8; }

/* Rebsorten-Eingabe (dynamische Zeilen) */
.wl-feldhint { font-weight: 400; text-transform: none; letter-spacing: 0; color: var(--nebel); font-size: 10.5px; }
.wl-rebliste { display: flex; flex-direction: column; gap: 8px; }
.wl-rebzeile { display: grid; grid-template-columns: 1fr 92px auto; gap: 8px; align-items: center; }
.wl-rebanteil { position: relative; display: flex; align-items: center; }
.wl-rebanteil .wl-eingabe { text-align: right; padding-right: 24px; }
.wl-rebprozent { position: absolute; right: 9px; color: var(--nebel); font-size: 12.5px; pointer-events: none; }
.wl-rebweg {
  width: 30px; height: 30px; flex: none; cursor: pointer; border-radius: 1px;
  border: 1px solid var(--linie-stark); background: transparent; color: var(--nebel);
  font-size: 18px; line-height: 1;
}
.wl-rebweg:hover:not(:disabled) { border-color: var(--granat); color: var(--granat); }
.wl-rebweg:disabled { opacity: 0.35; cursor: default; }

/* Ein-/Auslagerungshistorie */
.wl-historie { list-style: none; margin: 16px 0 0; padding: 0; display: flex; flex-direction: column; }
.wl-histzeile {
  display: grid; grid-template-columns: 130px auto auto 1fr auto auto; gap: 14px; align-items: baseline;
  padding: 9px 0; border-bottom: 1px solid var(--linie); font-size: 13px;
}
.wl-histquelle { color: var(--nebel); font-size: 12px; text-align: right; }
.wl-histart { font-size: 10px; text-transform: uppercase; letter-spacing: 0.12em; }
.wl-histart--zugang { color: var(--granat); }
.wl-histart--entnahme { color: var(--nebel); }
.wl-histmenge { color: var(--tinte); }
.wl-histjahr { color: var(--nebel); }
.wl-histdatum { color: var(--nebel); font-size: 12px; text-align: right; }
.wl-histart--weinkarte { color: var(--nebel); }
.wl-histart--kritik { color: var(--gold, #B9A15C); }

/* Trinkverlauf */
.wl-trinkverlauf { display: flex; flex-direction: column; }
.wl-tv-kennzahlen {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px;
  padding-bottom: 18px; border-bottom: 1px solid var(--linie-stark);
}
.wl-tv-kennzahl { display: flex; flex-direction: column; gap: 3px; }
.wl-tv-kennwert { font-size: 26px; line-height: 1.1; color: var(--tinte); }
.wl-tv-kennlabel {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--nebel);
}
.wl-tv-kennzusatz { font-size: 12px; color: var(--nebel); }
.wl-tv-filter {
  display: flex; flex-wrap: wrap; gap: 12px; align-items: center;
  justify-content: space-between; padding: 16px 0;
}
.wl-tv-arten button.aktiv { border-color: var(--granat); background: var(--granat); color: #fff; }
/* Drei Felder nebeneinander; auf schmalen Schirmen umbrechend, sonst
   liefen sie seitlich aus dem Dialog. */
.wl-tv-filterrest { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.wl-tv-filterrest .wl-eingabe { min-width: 150px; }
.wl-tv-filterrest select.wl-eingabe { min-width: 0; flex: 0 1 auto; }
.wl-tv-filterrest input.wl-eingabe { flex: 1 1 150px; }
@media (max-width: 760px) {
  .wl-tv-filterrest > * { flex: 1 1 140px; }
}
.wl-tv-monat { margin-top: 22px; }
.wl-tv-monatskopf {
  display: flex; align-items: baseline; justify-content: space-between; gap: 12px;
  padding-bottom: 6px; border-bottom: 1px solid var(--linie-stark);
}
.wl-tv-monatskopf h3 {
  margin: 0; font-family: var(--sans); font-size: 11px; font-weight: 500;
  text-transform: uppercase; letter-spacing: 0.14em; color: var(--tinte);
}
.wl-tv-monatssumme { font-size: 12px; color: var(--nebel); }
.wl-tv-monatssumme .ist-ein { color: var(--granat); }
.wl-tv-liste { list-style: none; margin: 0; padding: 0; }
/* Waagerecht schiebbar statt gequetscht: Die Zeilen behalten ihre
   Spaltenbreiten, auf schmalen Schirmen wandert man seitlich. */
.wl-tv-erfassen { display: flex; justify-content: flex-end; margin: 4px 0 14px; }
.wl-tv-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; scrollbar-width: thin; }
.wl-tv-spur { min-width: 520px; }
.wl-tv-zeile {
  display: grid; grid-template-columns: 46px 96px 104px minmax(140px, 1fr) auto auto;
  gap: 14px; align-items: baseline;
  padding: 9px 0; border-bottom: 1px solid var(--linie); font-size: 13px;
}
.wl-tv-tag { color: var(--nebel); font-size: 12px; }
/* Noch nicht zugeordnete Kritik */
.wl-tv-wein.ist-offen { border-left: 2px solid var(--gold, #B9A15C); padding-left: 8px; margin-left: -10px; }
.wl-tv-marke {
  display: inline-block; font-size: 10px; text-transform: uppercase;
  letter-spacing: 0.09em; color: var(--gold, #B9A15C);
}

/* Etikettenfeld im Kritik-Dialog.
   Der Rahmen hat feste Maße, weil .wl-foto auf height: 100% ausgelegt
   ist. Ohne ihn blieb die Höhe des Feldes hinter der des Bildes
   zurück, und die Knöpfe schoben sich in den Dialogfuß.
   (Keine Backticks in dieser Datei — sie ist ein Template-String.) */
.wl-kritikteilen { display: flex; align-items: flex-start; gap: 8px; margin: 10px 0 0; font-size: 13px; }
.wl-kritikteilen input { accent-color: var(--granat); margin-top: 2px; }

.wl-kritikfoto { display: flex; align-items: flex-start; gap: 14px; flex-wrap: wrap; }
.wl-kritikfoto-rahmen {
  flex: none; display: block; width: 96px; height: 128px; overflow: hidden;
  border: 1px solid var(--linie-stark); background: rgba(27, 25, 20, 0.04);
}
.wl-kritikfoto-aktionen { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
.wl-kritikfoto-fehler { flex-basis: 100%; margin-top: 0; }
.wl-kritikersatz {
  display: flex; align-items: flex-start; gap: 8px; margin: 14px 0 0;
  max-width: 64ch; font-size: 13px; color: var(--tinte);
}
.wl-kritikersatz input { accent-color: var(--granat); margin-top: 2px; }
/* Geliehen von der Entnahme, nicht selbst erfasst */
.wl-tv-tag.ist-geliehen { text-decoration: underline dotted; text-underline-offset: 3px; }
.wl-tv-menge { color: var(--tinte); }
.wl-tv-wein { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.wl-tv-wein .wl-textknopf { text-align: left; }
.wl-tv-zusatz { color: var(--nebel); font-size: 12px; }
.wl-tv-wert { color: var(--nebel); font-size: 12px; text-align: right; }

/* Statistik */
.wl-statumschalter { display: flex; gap: 26px; border-bottom: 1px solid var(--linie-stark); margin-bottom: 22px; }
.wl-statumschalter button {
  background: none; border: none; cursor: pointer; padding: 0 2px 10px;
  font-family: var(--sans); font-size: 11px; font-weight: 500;
  text-transform: uppercase; letter-spacing: 0.14em; color: var(--nebel);
  border-bottom: 1px solid transparent; margin-bottom: -1px;
}
.wl-statumschalter button:hover { color: var(--tinte); }
.wl-statumschalter button.aktiv { color: var(--tinte); border-bottom-color: var(--granat); }
.wl-statbewegung { margin-top: 40px; }
.wl-weltkarte { margin: 8px 0 40px; }
.wl-kartenrahmen { position: relative; margin-top: 12px; border: 1px solid var(--linie); background: #EEF1F0; }
.wl-weltsvg { display: block; width: 100%; height: auto; }
.wl-kartentooltip {
  position: absolute; top: 10px; left: 10px; pointer-events: none;
  background: var(--tinte); color: var(--kreide); padding: 7px 11px; border-radius: 2px;
  font-size: 12px; display: flex; flex-direction: column; gap: 2px; box-shadow: 0 6px 20px rgba(20,18,12,0.28);
}
.wl-kartentooltip .num { font-weight: 600; }
.wl-karteleer { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: var(--nebel); font-size: 13px; }
.wl-segment { display: inline-flex; border: 1px solid var(--linie-stark); border-radius: 2px; overflow: hidden; }
.wl-segbtn { background: none; border: none; padding: 6px 14px; font-family: var(--sans); font-size: 12px; color: var(--nebel); cursor: pointer; }
.wl-segbtn + .wl-segbtn { border-left: 1px solid var(--linie-stark); }
.wl-segbtn.ist-aktiv { background: var(--granat); color: var(--kreide); }
.wl-statgitter { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 34px 48px; }
.wl-statblock { min-width: 0; }
.wl-statblocktitel {
  font-family: var(--sans); font-size: 10.5px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.14em; color: var(--nebel);
  margin: 0 0 14px; padding-bottom: 8px; border-bottom: 1px solid var(--linie);
}
.wl-statsteuerung { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin: 0 0 22px; }
.wl-jahrfilter { width: auto; min-width: 130px; }

.wl-statbalken {
  display: grid; grid-template-columns: minmax(96px, 34%) 1fr auto;
  align-items: center; row-gap: 9px; column-gap: 12px;
}
/* Die Zeile reicht ihre drei Zellen an das Listen-Grid durch, damit
   alle Zeilen dieselben Spaltenbreiten teilen. */
.wl-statbalkenzeile { display: contents; }
.wl-statbalkenname { font-size: 12.5px; color: var(--tinte); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wl-statbalkenspur { height: 8px; background: var(--linie); border-radius: 1px; overflow: hidden; }
.wl-statbalkenfuell { display: block; height: 100%; border-radius: 1px; transition: width 0.35s ease; }
.wl-statbalkenwert { font-size: 12px; color: var(--tinte); white-space: nowrap; text-align: right; }
.wl-statbalkenanteil { color: var(--nebel); }
.wl-jgkatalog { margin-top: 10px; }
.wl-jgkatalog-titel {
  display: block; font-size: 10.5px; text-transform: uppercase;
  letter-spacing: 0.1em; color: var(--nebel); margin-bottom: 5px;
}
.wl-jgkatalog-jahre { display: flex; flex-wrap: wrap; gap: 6px; }
.wl-jgkatalog-jahr {
  padding: 5px 10px; border: 1px solid var(--linie-stark); background: none;
  border-radius: 999px; cursor: pointer;
  font-family: var(--sans); font-size: 12.5px; color: var(--tinte);
}
.wl-jgkatalog-jahr:hover { border-color: var(--granat); color: var(--granat); }
.wl-jgkatalog-jahr.ist-gewaehlt { background: var(--granat); border-color: var(--granat); color: #fff; }
.wl-jgkatalog-hinweis { margin: 8px 0 0; font-size: 12px; color: var(--gold, #B9A15C); }

/* Begrenzte Unterlisten (ui/begrenzt.jsx) */
.wl-mehrzeigen { display: flex; flex-wrap: wrap; align-items: baseline; gap: 6px 18px; padding: 12px 0 4px; font-size: 13px; }
.wl-mehrzeigen-stand { color: var(--nebel); font-size: 12px; }
.wl-kurzmehr { margin-left: 8px; font-size: 0.92em; white-space: nowrap; }
.wl-jahrlinks .wl-kurzmehr, .wl-appchips-rest .wl-kurzmehr { margin-left: 0; align-self: center; }
.wl-appchips-rest { display: contents; }

.wl-nachwachsen {
  padding: 14px 0 4px; text-align: center; font-size: 12px; color: var(--nebel);
}

.wl-statleer { font-size: 12.5px; color: var(--nebel); }

/* Leere Zustände & Laden */
.wl-leer { padding: 56px 24px; text-align: center; color: var(--nebel); }
.wl-leer p { font-family: var(--serif); font-size: 18px; max-width: 52ch; margin: 0 auto 18px; }
.wl-laden {
  min-height: 100vh; display: flex; flex-direction: column; gap: 12px;
  align-items: center; justify-content: center; color: var(--nebel); font-size: 12px;
  text-transform: uppercase; letter-spacing: 0.15em;
}

/* Sanfte Zustandsübergänge (werden bei reduzierter Bewegung deaktiviert) */
.wl-btn, .wl-textknopf, .wl-nav button, .wl-menueknopf, .wl-menuepunkt,
.wl-zeilentitel, .wl-nebenlink, .wl-filterknopf, .wl-zurueckknopf,
.wl-regionskarte.ist-klickbar, button.wl-regionsname.ist-link {
  transition: color 0.12s ease, border-color 0.12s ease, background-color 0.12s ease;
}
.wl-laden .wl-marke, .wl-laden .wl-logo { animation: wl-puls 1.8s ease-in-out infinite; }
.wl-laden .wl-logo { margin-bottom: 4px; }
@keyframes wl-puls { 0%, 100% { opacity: 1; } 50% { opacity: 0.45; } }

/* Feine Rollbalken in Tabellencontainern */
.wl-scroll { -webkit-overflow-scrolling: touch; scrollbar-width: thin; }

/* Responsiv & Bewegungsreduktion */
@media (max-width: 760px) {
  .wl-shell { padding: 0 18px 72px; }
  .wl-header { padding-top: 24px; }
  .wl-nav { gap: 18px; width: 100%; }
  .wl-nav button { margin-bottom: 0; padding-bottom: 6px; }
  .wl-formgitter { grid-template-columns: 1fr; }
  .wl-zweispalt { grid-template-columns: 1fr; }
  .wl-ledger {
    gap: 10px; flex-wrap: nowrap; justify-content: space-between;
    padding: 13px 0; margin-bottom: 20px; overflow-x: auto;
  }
  .wl-kennzahl { font-size: 17px; }
  .wl-kennname { font-size: 8px; letter-spacing: 0.09em; margin-top: 3px; white-space: nowrap; }
  .wl-titel { font-size: 29px; }
  .wl-seitenkopf { margin-top: 32px; }
  .wl-werkzeuge-links { width: 100%; }
  /* Nicht auf volle Breite zwingen — sonst rutschen die Symbolknöpfe
     in die nächste Zeile. Die Hülle darf schrumpfen, ein Rest bleibt
     tippbar. */
  .wl-suche { width: 100%; min-width: 90px; }
  .wl-werkzeuge-links { gap: 6px; }
  .wl-werkzeuge > .wl-btn { flex: 1 1 100%; }
  .wl-filterleiste .wl-eingabe { max-width: none; flex: 1 1 100%; }
  .wl-filterleiste .wl-mehrfach { max-width: none; flex: 1 1 100%; }
  .wl-filterleiste .wl-mehrfach-liste { width: 100%; max-width: none; }
  .wl-sortauswahl { flex: 1 1 100%; max-width: none; }
  .wl-statgitter { grid-template-columns: 1fr; gap: 26px; }
  .wl-statbalken { grid-template-columns: minmax(80px, 40%) 1fr auto; column-gap: 8px; }
  /* Historie bricht auf schmalen Bildschirmen um. */
  .wl-histzeile { grid-template-columns: 1fr auto; gap: 4px 10px; }
  .wl-histquelle, .wl-histdatum { text-align: left; }
  .wl-schleier { padding: 4vh 10px 12px; }
  .wl-modal { padding: 20px 18px 24px; }
  .wl-karte iframe { height: 230px; }
  .wl-fuss { flex-direction: column; gap: 6px; }
  /* Breite Tabellen: horizontal wischen, erste Spalte bleibt stehen */
  .wl-scroll .wl-tabelle { min-width: 640px; }
  .wl-scroll .wl-tabelle th:first-child,
  .wl-scroll .wl-tabelle td:first-child {
    position: sticky; left: 0; z-index: 1; background: var(--kreide);
  }
}
@media (prefers-reduced-motion: reduce) {
  .wl-root * { animation: none !important; transition: none !important; }
}

/* Druck: reduziert auf das Hauptbuch — ohne Bedienelemente */
@media print {
  .wl-root { background: #FFFFFF; }
  .wl-shell { max-width: none; padding: 0; }
  .wl-nav, .wl-hauptmenue, .wl-aktionen, .wl-werkzeuge-block, .wl-menue, .wl-kartenaktionen,
  .wl-zurueck, .wl-kritikzelle .ist-dezent, .wl-syncstatus, .wl-refresh, .wl-witterungssteuerung { display: none !important; }
  .wl-karte iframe { display: none; }
  .wl-scroll { overflow: visible; }
  .wl-tabelle td, .wl-tabelle th { padding: 8px 10px; }
}

/* Teilen & Weinkarten (Dialoge) */
.wl-teil { display: flex; flex-direction: column; gap: 14px; }
.wl-teil-info { font-size: 13px; color: var(--nebel); line-height: 1.5; margin: 0; }
.wl-teil-link { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.wl-teil-link .wl-eingabe { flex: 1; min-width: 180px; font-size: 12px; }
.wl-teil-widerruf { color: var(--granat); }
.wl-teil-fuss { display: flex; gap: 8px; justify-content: flex-end; flex-wrap: wrap; margin-top: 4px; }
.wl-teil-trenner { height: 1px; background: var(--linie); margin: 4px 0; }
.wl-karte-anlegen { display: flex; gap: 8px; align-items: center; }
.wl-karte-anlegen .wl-eingabe { flex: 1; }
.wl-karte-uebersicht, .wl-karte-liste { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
.wl-karte-zeile { display: flex; align-items: center; gap: 10px; justify-content: space-between; border: 1px solid var(--linie); border-radius: 4px; padding: 8px 10px; }
.wl-karte-zeile-text { background: none; border: none; text-align: left; cursor: pointer; display: flex; flex-direction: column; gap: 2px; flex: 1; padding: 0; font: inherit; color: inherit; }
.wl-karte-zeile-name { font-family: var(--serif); font-weight: 600; font-size: 15px; }
.wl-karte-zeile-info { font-size: 12px; color: var(--nebel); }
.wl-karte-zeile-aktion { display: flex; gap: 6px; align-items: center; }
.wl-karte-editor { display: flex; flex-direction: column; gap: 12px; }
.wl-karte-pos { display: flex; align-items: center; gap: 10px; border-bottom: 1px solid var(--linie); padding-bottom: 8px; }
.wl-karte-pos-text { flex: 1; display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.wl-karte-pos-name { font-weight: 600; font-size: 14px; }
.wl-karte-pos-neben { font-size: 12px; color: var(--nebel); }
.wl-karte-pos-preis { display: flex; align-items: center; gap: 4px; }
.wl-karte-pos-preis .wl-eingabe { width: 84px; text-align: right; }
.wl-karte-eur { color: var(--nebel); font-size: 13px; }
.wl-karte-neu { display: flex; flex-direction: column; gap: 10px; border: 1px dashed var(--linie); border-radius: 4px; padding: 12px; }
.wl-karte-neu-zeile { display: flex; gap: 10px; }
.wl-karte-neu-zeile .wl-feld { flex: 1; }

/* Konto (Mein Konto, Passwort vergessen, Passwort setzen) */
.wl-konto-block { display: flex; flex-direction: column; gap: 10px; }
.wl-konto-titel { font-family: var(--serif); font-weight: 600; font-size: 16px; }
.wl-konto-ok { color: var(--zugang); font-size: 13px; margin: 0; }
.wl-konto-zurueck { display: block; margin: 10px auto 0; font-size: 13px; color: var(--nebel); background: none; border: none; cursor: pointer; }
.wl-konto-zurueck:hover { color: var(--granat); }

/* Öffentliche, schreibgeschützte Ansicht (/geteilt/<token>) */
.wl-oeff-root { min-height: 100vh; }
.wl-oeff-huelle { max-width: 760px; margin: 0 auto; padding: 20px 16px 48px; }
.wl-oeff-kopf { display: flex; align-items: baseline; gap: 12px; flex-wrap: wrap; border-bottom: 2px solid var(--granat); padding-bottom: 12px; margin-bottom: 16px; }
.wl-oeff-marke { font-family: var(--serif); font-size: 26px; font-weight: 700; color: var(--granat); }
.wl-oeff-unter { font-family: var(--serif); font-size: 18px; }
.wl-oeff-nurlesen { margin-left: auto; font-size: 11px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--nebel); border: 1px solid var(--linie); border-radius: 999px; padding: 2px 10px; }
.wl-oeff-zusammen { font-size: 12px; color: var(--nebel); margin-bottom: 10px; }
.wl-oeff-suche { width: 100%; margin-bottom: 16px; }
.wl-oeff-liste, .wl-oeff-karte { list-style: none; margin: 0; padding: 0; }
.wl-oeff-wein { border-bottom: 1px solid var(--linie); padding: 12px 0; }
.wl-oeff-weinkopf { display: flex; align-items: center; gap: 8px; }
.wl-oeff-typ { width: 9px; height: 9px; border-radius: 50%; flex: none; display: inline-block; }
.wl-oeff-weinname { font-family: var(--serif); font-weight: 600; font-size: 17px; flex: 1; }
.wl-oeff-bestand { font-size: 13px; color: var(--nebel); white-space: nowrap; }
.wl-oeff-meta { display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 13px; color: var(--nebel); margin-top: 4px; }
.wl-oeff-jahrgaenge { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
.wl-oeff-jg { font-size: 12px; border: 1px solid var(--linie); border-radius: 3px; padding: 2px 8px; }
.wl-oeff-jg em { color: var(--nebel); font-style: normal; margin-left: 6px; }
.wl-oeff-kartepos { border-bottom: 1px solid var(--linie); padding: 12px 0; }
.wl-oeff-kartekopf { display: flex; align-items: baseline; gap: 8px; }
.wl-oeff-jahr { color: var(--nebel); font-size: 14px; }
.wl-oeff-preis { margin-left: auto; font-family: var(--serif); font-weight: 600; font-size: 16px; white-space: nowrap; }
.wl-oeff-notiz { font-size: 13px; color: var(--nebel); margin: 6px 0 0; font-style: italic; }
.wl-oeff-leer, .wl-oeff-fehler { color: var(--nebel); font-size: 14px; padding: 20px 0; }
.wl-oeff-fehler { color: var(--granat); }
.wl-oeff-fuss { margin-top: 24px; padding-top: 12px; border-top: 1px solid var(--linie); font-size: 11px; color: var(--nebel); text-align: center; }

/* Weinkarte: Feldauswahl, QR, Admin-Schalter */
.wl-karte-felder { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 6px 14px; }
.wl-karte-feld { display: flex; align-items: center; gap: 8px; font-size: 13px; cursor: pointer; }
.wl-qr-block { display: flex; flex-direction: column; align-items: center; gap: 6px; width: 100%; margin-top: 6px; }
.wl-qr { border: 1px solid var(--linie); border-radius: 4px; }
.wl-proschalter { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; color: var(--nebel); cursor: pointer; }
.wl-oeff-drucken { margin-top: 22px; text-align: center; }
.wl-knopf-linie { background: none; border: 1px solid var(--linie); border-radius: 3px; padding: 8px 16px; font: inherit; font-size: 13px; cursor: pointer; color: var(--tinte); }
.wl-knopf-linie:hover { border-color: var(--granat); color: var(--granat); }
.wl-druck-titel { font-family: var(--serif); font-size: 26px; margin: 0 0 4px; }

/* Direkter Browserdruck der geteilten Ansicht: Bedienelemente weg,
   Positionen nicht über Seitenumbrüche reißen. */
@media print {
  .wl-oeff-suche, .wl-oeff-nurlesen, .wl-oeff-fuss { display: none !important; }
  .wl-oeff-kartepos { break-inside: avoid; }
  .wl-oeff-huelle { max-width: none; padding: 0; }
  @page { margin: 18mm; }
}

/* Weinkarten-Editor: Positionsliste nach Wein gruppiert,
   ein-/ausklappbar und durchsuchbar. */
.wl-karte-listenkopf { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.wl-karte-listensuche { flex: 1; min-width: 160px; }
.wl-karte-gruppen { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 6px; }
.wl-karte-gruppe { border: 1px solid var(--linie); border-radius: 4px; padding: 6px 10px; }
.wl-karte-gruppenkopf { display: flex; align-items: baseline; gap: 8px; width: 100%; padding: 4px 0; flex-wrap: wrap; }
/* Schalter für die gesamte Liste. */
.wl-karte-listenschalter { display: flex; align-items: baseline; gap: 6px; background: none; border: none; padding: 4px 0; font: inherit; font-weight: 600; color: inherit; cursor: pointer; }
.wl-karte-listenschalter:hover:not(:disabled) { color: var(--granat); }
.wl-karte-listenschalter:disabled { cursor: default; opacity: 0.55; }
.wl-karte-pfeil { color: var(--nebel); font-size: 11px; flex: none; }
.wl-karte-gruppenname { font-weight: 600; font-size: 14px; }
.wl-karte-gruppenneben { font-size: 12px; color: var(--nebel); }
.wl-karte-gruppeninfo { margin-left: auto; font-size: 12px; color: var(--nebel); white-space: nowrap; }
.wl-karte-gruppe .wl-karte-liste { margin-top: 4px; }
.wl-karte-gruppe .wl-karte-pos:last-child { border-bottom: none; padding-bottom: 2px; }

/* Öffentliche Ansicht: Bereiche, Gruppen, Eingrenzung */
.wl-oeff-reiter { display: flex; gap: 4px; border-bottom: 1px solid var(--linie); margin-bottom: 14px; flex-wrap: wrap; }
.wl-oeff-reiter button { background: none; border: none; border-bottom: 2px solid transparent; padding: 8px 12px; font: inherit; font-size: 14px; color: var(--nebel); cursor: pointer; margin-bottom: -1px; }
.wl-oeff-reiter button:hover { color: var(--tinte); }
.wl-oeff-reiter button.aktiv { color: var(--granat); border-bottom-color: var(--granat); font-weight: 600; }
.wl-oeff-eingrenzung { display: flex; align-items: center; gap: 10px; font-size: 13px; background: var(--kreide); border: 1px solid var(--linie); border-radius: 3px; padding: 6px 10px; margin-bottom: 10px; }
.wl-oeff-eingrenzung button { background: none; border: none; color: var(--granat); font: inherit; font-size: 13px; cursor: pointer; margin-left: auto; }
.wl-oeff-zeilenknopf { display: flex; align-items: center; gap: 8px; width: 100%; background: none; border: none; padding: 0; font: inherit; color: inherit; text-align: left; cursor: pointer; }
.wl-oeff-zeilenknopf:hover .wl-oeff-weinname { color: var(--granat); }
.wl-oeff-gruppe { margin-bottom: 18px; }
.wl-oeff-gruppentitel { font-family: var(--serif); font-size: 15px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; color: var(--nebel); margin: 18px 0 6px; padding-bottom: 4px; border-bottom: 1px solid var(--linie); }
@media print {
  .wl-oeff-reiter, .wl-oeff-eingrenzung { display: none !important; }
  .wl-oeff-gruppentitel { break-after: avoid; }
  .wl-oeff-gruppe { break-inside: auto; }
}

/* Katalog: Übernahme im Formular, Modusschalter im Menü */
.wl-kat { border: 1px solid var(--linie); border-radius: 4px; padding: 12px; margin-bottom: 16px; background: var(--kreide); }
.wl-kat-kopf { display: flex; align-items: baseline; gap: 8px; margin-bottom: 8px; flex-wrap: wrap; }
.wl-kat-titel { font-family: var(--serif); font-weight: 600; font-size: 15px; }
.wl-kat-anzahl { font-size: 11px; color: var(--nebel); margin-left: auto; }
.wl-kat-liste { list-style: none; margin: 8px 0 0; padding: 0; display: flex; flex-direction: column; gap: 2px; max-height: 220px; overflow-y: auto; }
.wl-kat-treffer { display: flex; flex-direction: column; gap: 1px; width: 100%; text-align: left; background: none; border: none; border-radius: 3px; padding: 6px 8px; font: inherit; color: inherit; cursor: pointer; }
.wl-kat-treffer:hover { background: #fff; }
.wl-kat-name { font-weight: 600; font-size: 14px; }
.wl-kat-neben { font-size: 12px; color: var(--nebel); }
.wl-kat-leer { font-size: 13px; color: var(--nebel); margin: 8px 0 0; }
.wl-kat-trenner { display: flex; align-items: center; gap: 10px; margin-top: 12px; font-size: 11px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--nebel); }
.wl-kat-trenner::before, .wl-kat-trenner::after { content: ""; flex: 1; height: 1px; background: var(--linie); }
/* Zweiter Schritt der Katalogsuche: Weine eines gewählten Winzers. */
.wl-kat-zurueck { margin-left: auto; background: none; border: none; padding: 0; font: inherit; font-size: 12px; color: var(--nebel); cursor: pointer; }
.wl-kat-zurueck:hover { color: var(--granat); }
.wl-kat-gruppe { margin: 10px 0 0; font-size: 11px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--nebel); }
.wl-kat-eigener { width: 100%; margin-top: 10px; background: none; border: 1px solid var(--linie); border-radius: 3px; padding: 8px; font: inherit; font-size: 13px; color: inherit; cursor: pointer; }
.wl-kat-eigener:hover { border-color: var(--granat); color: var(--granat); }
.wl-hm-modus { display: flex; flex-direction: column; gap: 6px; padding: 12px 16px; border-bottom: 1px solid var(--linie); }
.wl-hm-modusschalter { display: inline-flex; border: 1px solid var(--linie); border-radius: 3px; overflow: hidden; align-self: flex-start; }
.wl-hm-modusschalter button { background: none; border: none; padding: 6px 16px; font: inherit; font-size: 13px; cursor: pointer; color: var(--nebel); }
.wl-hm-modusschalter button.aktiv { background: var(--granat); color: #fff; font-weight: 600; }
.wl-hm-modushinweis { font-size: 11.5px; color: var(--nebel); line-height: 1.4; }

/* Vorschläge */
.wl-vs-liste { list-style: none; margin: 8px 0 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
.wl-vs-zeile { border: 1px solid var(--linie); border-radius: 4px; padding: 10px 12px; display: flex; flex-direction: column; gap: 6px; }
.wl-vs-kopf { display: flex; align-items: baseline; gap: 6px 8px; flex-wrap: wrap; }
.wl-vs-name { font-family: var(--serif); font-weight: 600; font-size: 15px; flex: 1; }
.wl-vs-status { font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em; border: 1px solid var(--linie); border-radius: 999px; padding: 2px 8px; white-space: nowrap; }
.wl-vs-status.ist-angenommen { color: var(--zugang); border-color: var(--zugang); }
.wl-vs-status.ist-abgelehnt { color: var(--granat); border-color: var(--granat); }
.wl-vs-status.ist-dublette { color: var(--granat); border-color: var(--granat); }
.wl-zf-kandidaten { flex-direction: column; align-items: flex-start; gap: 6px; }
.wl-zf-kandidat { display: flex; flex-direction: column; gap: 1px; }
.wl-vs-aehnlich .wl-vs-merkmale { font-size: 12px; color: var(--nebel); }
.wl-vs-meta { font-size: 12px; color: var(--nebel); }
.wl-vs-begruendung { font-size: 13px; margin: 0; font-style: italic; }
.wl-vs-hinweis { font-size: 12px; color: var(--nebel); margin: 0; }
.wl-vs-diff { list-style: none; margin: 2px 0; padding: 0; display: flex; flex-direction: column; gap: 3px; font-size: 12.5px; }
.wl-vs-diff li { display: flex; align-items: baseline; gap: 6px; flex-wrap: wrap; }
.wl-vs-feld { color: var(--nebel); min-width: 84px; }
.wl-vs-alt { text-decoration: line-through; color: var(--nebel); }
.wl-vs-pfeil { color: var(--nebel); }
.wl-vs-neu { font-weight: 600; }
.wl-vs-grund { font-size: 13px; }
.wl-vs-aktionen { display: flex; gap: 8px; }
.wl-vs-sammel { display: flex; flex-wrap: wrap; gap: 12px; font-size: 13px; }

/* Zusammenführen */
.wl-zf-arten { display: flex; gap: 4px; border-bottom: 1px solid var(--linie); }
.wl-zf-arten button { background: none; border: none; border-bottom: 2px solid transparent; padding: 7px 12px; font: inherit; font-size: 13px; color: var(--nebel); cursor: pointer; margin-bottom: -1px; }
.wl-zf-arten button.aktiv { color: var(--granat); border-bottom-color: var(--granat); font-weight: 600; }
.wl-zf-dubletten ul { list-style: none; margin: 6px 0 0; padding: 0; display: flex; flex-direction: column; gap: 4px; font-size: 13px; }
.wl-zf-vorschau { border: 1px solid var(--granat); border-radius: 4px; padding: 10px 12px; display: flex; flex-direction: column; gap: 8px; }

/* Zusammenführen: Feldvergleich.
   Drei Spalten, damit Quelle und Ziel untereinander stehen; nur die
   abweichenden Zeilen sind hervorgehoben — der Rest soll ruhig
   bleiben, sonst sieht alles nach Problem aus. */
.wl-zf-vergleich { margin: 18px 0 4px; }
.wl-zf-urteil { margin: 0 0 12px; max-width: 64ch; font-size: 13px; }
.wl-zf-urteil.ist-gut { color: var(--tinte); }
.wl-zf-urteil.ist-warnung { color: var(--granat); }
.wl-zf-vgl { border-top: 1px solid var(--linie-stark); }
.wl-zf-vgl-kopf, .wl-zf-vgl-zeile {
  display: grid; grid-template-columns: minmax(120px, 1fr) 1fr 1fr; gap: 10px 16px;
  align-items: baseline; padding: 7px 0; border-bottom: 1px solid var(--linie);
}
.wl-zf-vgl-kopf {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.1em;
  color: var(--nebel); border-bottom-color: var(--linie-stark);
}
.wl-zf-vgl-feld { font-size: 12.5px; color: var(--nebel); }
.wl-zf-vgl-wert { font-size: 13px; word-break: break-word; }
.wl-zf-vgl-marke {
  display: block; font-size: 9.5px; text-transform: uppercase; letter-spacing: 0.09em;
  color: var(--nebel);
}
.wl-zf-vgl-zeile.ist-gleich { opacity: 0.62; }
.wl-zf-vgl-zeile.ist-ergaenzt .wl-zf-vgl-marke { color: var(--gold, #B9A15C); }
.wl-zf-vgl-zeile.ist-konflikt .wl-zf-vgl-feld,
.wl-zf-vgl-zeile.ist-konflikt .wl-zf-vgl-marke { color: var(--granat); }
.wl-zf-vgl-zeile.ist-konflikt .wl-zf-vgl-wert { font-weight: 600; }
.wl-zf-dubgruppe { list-style: none; margin: 0; padding: 0 0 0 12px; border-left: 1px solid var(--linie); }
.wl-zf-dubgruppe li { display: flex; gap: 10px; flex-wrap: wrap; align-items: baseline; padding: 2px 0; }

/* Rohansicht (nur Admin) */
.wl-zf-roh { margin-top: 14px; }
.wl-zf-rohpaar { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-top: 10px; }
.wl-zf-rohtitel { display: block; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.1em; color: var(--nebel); margin-bottom: 4px; }
.wl-zf-rohpaar pre {
  margin: 0; padding: 10px; max-height: 320px; overflow: auto;
  background: rgba(27, 25, 20, 0.04); border: 1px solid var(--linie);
  font-size: 11px; line-height: 1.45; white-space: pre; font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
@media (max-width: 760px) {
  .wl-zf-vgl-kopf, .wl-zf-vgl-zeile { grid-template-columns: minmax(88px, 1fr) 1fr 1fr; gap: 8px 10px; }
  .wl-zf-vgl-wert { font-size: 12.5px; }
  .wl-zf-rohpaar { grid-template-columns: 1fr; }
}
.wl-zf-vorschau p { margin: 0; font-size: 13px; }

/* Filter- und Sortierleiste der geteilten Ansichten */
.wl-oefffilter { display: flex; flex-direction: column; gap: 8px; margin-bottom: 14px; }
.wl-oefffilter-reihe { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
.wl-oefffilter-reihe .wl-auswahl { font-size: 12.5px; padding: 5px 8px; }
.wl-oefffilter-reset { background: none; border: none; color: var(--granat); font: inherit; font-size: 12.5px; cursor: pointer; padding: 4px; }
@media print { .wl-oefffilter { display: none !important; } }

/* Weinkarten-Auswertung in der Statistik */
.wl-kartenauswertung { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-bottom: 12px; }
.wl-kartenumsatz { font-size: 13px; color: var(--nebel); }
.wl-karte-pos-aktionen { display: flex; align-items: center; gap: 10px; }
.wl-karte-pos-menge { display: flex; align-items: center; gap: 4px; }
.wl-karte-pos-menge .wl-eingabe { width: 62px; text-align: right; }

/* Kompaktes Menü mit Untergruppen */
.wl-hm-kopf { display: flex; flex-direction: column; gap: 2px; padding: 12px 16px 10px; border-bottom: 1px solid var(--linie); }
.wl-hm-stand { font-size: 11.5px; color: var(--nebel); }
.wl-hm-stand.ist-offline { color: var(--granat); }
.wl-hm-stand.ist-fehler { color: var(--granat); font-weight: 600; }
.wl-hm-gruppe { display: flex; align-items: center; gap: 8px; }
.wl-hm-gruppe > span:first-child { flex: 1; }
.wl-hm-pfeil { color: var(--nebel); font-size: 16px; line-height: 1; }
.wl-hm-zaehler { background: var(--granat); color: #fff; font-size: 10.5px; font-weight: 600; border-radius: 999px; padding: 1px 7px; }
.wl-hm-zurueck { display: flex; align-items: center; gap: 6px; width: 100%; background: none; border: none; border-bottom: 1px solid var(--linie); padding: 11px 16px; font: inherit; font-family: var(--serif); font-weight: 600; font-size: 15px; color: var(--tinte); cursor: pointer; text-align: left; }
.wl-hm-zurueck:hover { color: var(--granat); }

.wl-hm-standzeile { display: flex; flex-direction: column; gap: 2px; padding: 10px 16px; border-bottom: 1px solid var(--linie); }
.wl-hm-marke { font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.1em; color: var(--granat); border: 1px solid var(--granat); border-radius: 999px; padding: 1px 7px; }
.wl-hm-punkt .wl-hm-marke { margin-left: 8px; }

/* Synchronisation: Gegenüberstellung beider Stände. Drei Spalten,
   damit die Zahlen untereinander stehen und der Unterschied ohne
   Suchen ins Auge fällt. */
.wl-syncvgl { margin: 22px 0 4px; border-top: 1px solid var(--linie-stark); }
.wl-syncvgl-kopf, .wl-syncvgl-zeile {
  display: grid; grid-template-columns: 1fr auto auto; gap: 12px 24px;
  align-items: baseline; padding: 8px 0; border-bottom: 1px solid var(--linie);
}
.wl-syncvgl-kopf {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.12em;
  color: var(--nebel); border-bottom-color: var(--linie-stark);
}
.wl-syncvgl-name { font-size: 13px; color: var(--nebel); }
.wl-syncvgl-wert { min-width: 84px; text-align: right; font-size: 13.5px; }
.wl-syncvgl-kopf .wl-syncvgl-wert { font-size: inherit; }
.wl-syncvgl-zeile.ist-anders .wl-syncvgl-name { color: var(--tinte); }
.wl-syncvgl-zeile.ist-anders .wl-syncvgl-wert { font-weight: 600; color: var(--granat); }
/* Einzelheiten eines Konflikts: was, hier, Server. Die Werte dürfen
   umbrechen — ein Lagerort oder eine Notiz ist keine Zahl. */
.wl-syncdetail { margin: 14px 0 4px; border-top: 1px solid var(--linie-stark); }
.wl-syncdetail-kopf, .wl-syncdetail-zeile {
  display: grid; grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr) minmax(0, 1fr); gap: 4px 12px;
  align-items: baseline; padding: 7px 0; border-bottom: 1px solid var(--linie);
}
.wl-syncdetail-zeile--zwei { grid-template-columns: minmax(0, 1fr) auto; }
.wl-syncdetail-kopf {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.08em;
  color: var(--nebel); border-bottom-color: var(--linie-stark);
}
.wl-syncdetail-was { display: flex; flex-direction: column; min-width: 0; }
.wl-syncdetail-titel { font-size: 13px; overflow-wrap: anywhere; }
.wl-syncdetail-feld { font-size: 12px; color: var(--nebel); }
.wl-syncdetail-wert { font-size: 13px; overflow-wrap: anywhere; }
/* Etikett, das noch auf die Übertragung wartet */
.wl-fotohuelle { position: relative; display: inline-block; line-height: 0; }
.wl-fotowartet {
  position: absolute; left: 6px; bottom: 6px; line-height: 1;
  background: rgba(28, 26, 24, 0.78); color: #fff; border-radius: 3px;
  padding: 3px 6px; font-size: 10px; letter-spacing: 0.04em;
  text-transform: uppercase; font-family: var(--sans);
}

.wl-syncwarnung {
  margin: 16px 0 0; padding: 10px 12px; max-width: 64ch;
  border-left: 2px solid var(--granat); background: rgba(114, 47, 55, 0.05);
  font-size: 13px; color: var(--tinte);
}
/* Auf dem Telefon ist der Dialog schmal; die beiden Zahlenspalten
   rücken zusammen, damit die Zeile nicht seitlich ausbricht. */
@media (max-width: 760px) {
  .wl-syncvgl-kopf, .wl-syncvgl-zeile { gap: 8px 12px; }
  .wl-syncvgl-wert { min-width: 62px; }
  .wl-syncvgl-name { font-size: 12.5px; }
  .wl-syncvgl-kopf { letter-spacing: 0.06em; }
  /* Drei Knöpfe passen nebeneinander nicht mehr auf eine Zeile. */
  .wl-syncfuss { flex-wrap: wrap; gap: 10px; justify-content: flex-end; }
  .wl-syncfuss .wl-modalfuss-rechts { flex: 1; justify-content: flex-end; }
}

.wl-oefffilter-kopf { display: flex; gap: 6px; align-items: center; flex-wrap: wrap; }
.wl-oefffilter-kopf .wl-oeff-suche { flex: 1; min-width: 160px; margin: 0; }

.wl-karte-einstand { font-size: 12.5px; color: var(--nebel); margin: -2px 0 0; }

.wl-kartenzahlen { display: flex; flex-wrap: wrap; gap: 4px 18px; font-size: 12.5px; color: var(--nebel); }
.wl-kartenzahlen em { font-style: normal; font-weight: 600; color: var(--tinte); font-family: var(--serif); font-size: 14px; }
.wl-kartenzahlen .ist-gewinn em { color: var(--zugang); }
.wl-kartenzahlen .ist-verlust em { color: var(--granat); }
.wl-kartenzahlen .ist-hinweis { color: var(--granat); }

/* Jahrgangstabelle in der gruppierten Weinliste — feste Spalten */
.wl-oeff-jgtabelle { width: 100%; border-collapse: collapse; margin-top: 6px; font-size: 13px; }
.wl-oeff-jgtabelle td { padding: 2px 0; vertical-align: baseline; }
.wl-oeff-jgjahr { width: 5.5em; color: var(--nebel); }
.wl-oeff-jgmenge { width: 5em; color: var(--nebel); }
.wl-oeff-jgpreis { text-align: right; font-family: var(--serif); font-weight: 600; white-space: nowrap; }

.wl-oeff-zurueckknopf { background: none; border: none; font: inherit; font-size: 13px; color: var(--granat); cursor: pointer; padding: 0; }
.wl-oeff-eingrenzungwert { font-size: 13px; color: var(--nebel); margin-left: auto; }

/* Detailsichten der geteilten Weinkarte */
.wl-oeff-detail { display: flex; flex-direction: column; gap: 10px; }
.wl-oeff-detailname { font-family: var(--serif); font-size: 24px; margin: 6px 0 0; display: flex; align-items: center; gap: 8px; }
.wl-oeff-verweis, .wl-oeff-verweisname { background: none; border: none; padding: 0; font: inherit; color: var(--granat); cursor: pointer; text-align: left; }
.wl-oeff-verweisname { font-family: var(--serif); font-weight: 600; font-size: 17px; flex: 1; }
.wl-oeff-beschreibung { font-size: 14px; line-height: 1.55; margin: 4px 0; }
.wl-oeff-rebsorten { font-size: 13px; color: var(--nebel); margin: 0; }
.wl-oeff-analytik { font-size: 13px; margin: 2px 0; }
.wl-oeff-jgblock { border-top: 1px solid var(--linie); padding-top: 10px; margin-top: 6px; }
.wl-oeff-jgkopf { display: flex; align-items: baseline; gap: 8px; }
.wl-oeff-jgtitel { font-family: var(--serif); font-weight: 600; font-size: 17px; flex: 1; }
.wl-oeff-detailblock { margin-top: 10px; }
.wl-oeff-detailtitel { font-size: 11px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--nebel); margin: 0 0 6px; }
.wl-oeff-kritiken { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
.wl-oeff-kritiker { font-weight: 600; font-size: 14px; margin-right: 8px; }
.wl-oeff-punkte { font-family: var(--serif); font-weight: 600; color: var(--gold); }
.wl-oeff-kennzahlen { display: grid; grid-template-columns: repeat(auto-fit, minmax(110px, 1fr)); gap: 8px; margin: 0; }
.wl-oeff-kennzahlen dt { font-size: 11px; color: var(--nebel); text-transform: uppercase; letter-spacing: 0.08em; }
.wl-oeff-kennzahlen dd { margin: 0; font-family: var(--serif); font-weight: 600; font-size: 16px; }
.wl-oeff-etikett { background: none; border: 1px solid var(--linie); border-radius: 4px; padding: 0; cursor: pointer; margin-top: 8px; overflow: hidden; }
.wl-oeff-etikett img { display: block; max-width: 160px; height: auto; }

/* Sprachwahl */
.wl-sprachwahl { font: inherit; font-size: 12.5px; padding: 4px 8px; border: 1px solid var(--linie); border-radius: 3px; background: #fff; color: var(--tinte); }
.wl-oeff-kopfrechts { margin-left: auto; display: flex; align-items: center; gap: 8px; }
@media print { .wl-oeff-kopfrechts { display: none !important; } }

/* Dublettenabgleich und angereicherte Vorschläge */
.wl-vs-sammelpaar { display: inline-flex; gap: 10px; align-items: center; }
.wl-vs-kontext { display: flex; flex-wrap: wrap; gap: 3px 12px; font-size: 12.5px; color: var(--nebel); }
.wl-vs-marke { color: var(--granat); }
.wl-vs-aehnlich { border-left: 2px solid var(--linie); padding-left: 10px; margin-top: 4px; }
.wl-vs-aehnlich ul { list-style: none; margin: 4px 0 0; padding: 0; display: flex; flex-direction: column; gap: 6px; }
.wl-vs-aehnlich li { display: flex; flex-wrap: wrap; align-items: baseline; gap: 4px 10px; font-size: 13px; }
/* Unterschiede: Jahrgänge eingerückt unter ihrem Jahr, Feldkonflikte
   (auch im Katalog geändert) mit granatfarbener Randlinie. */
.wl-vs-diff li.ist-konflikt { border-left: 2px solid var(--granat); padding-left: 6px; }
.wl-vs-konflikt { font-size: 11px; color: var(--granat); }
.wl-vs-jg { flex-direction: column; align-items: flex-start; gap: 2px; }
.wl-vs-jgkopf { display: flex; align-items: baseline; gap: 8px; }
.wl-vs-jgjahr { font-family: var(--serif); font-weight: 600; }
.wl-vs-jgart { font-size: 12px; color: var(--nebel); }
.wl-vs-jgfelder { padding-left: 12px; }
.wl-vs-neumarke { font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em; color: var(--granat); }
.wl-vs-ergebnis { display: flex; flex-direction: column; gap: 4px; }
.wl-vs-korrektur { display: flex; flex-direction: column; gap: 6px; border-left: 2px solid var(--linie); padding-left: 10px; }
.wl-vs-korrekturfeld { display: flex; flex-direction: column; gap: 2px; font-size: 13px; }
.wl-vs-aktionen--umbruch { flex-wrap: wrap; align-items: center; }
.wl-zf-offen { list-style: none; margin: 8px 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
.wl-zf-offen li { border: 1px solid var(--linie); border-radius: 4px; padding: 8px 10px; }
.wl-zf-offenkopf { display: flex; flex-direction: column; gap: 2px; margin-bottom: 6px; }
.wl-zf-offenkopf .wl-vs-status { align-self: flex-start; }
.wl-zf-kandidat > button { text-align: left; }

/* ================================================================
   Kein Hineinzoomen beim Antippen eines Feldes.

   Safari auf iOS zoomt die Seite heran, sobald ein fokussiertes
   Eingabefeld kleiner als 16 px gesetzt ist — danach muss von Hand
   wieder herausgezoomt werden. Auf Zeigegeräten ohne Tastatur am
   Bildschirm passiert das nicht, deshalb greift die Regel nur bei
   grobem Zeiger (Finger).

   Der naheliegende Ausweg wäre maximum-scale=1 im Viewport-Tag.
   Das ist keiner: Damit ließe sich die Seite überhaupt nicht mehr
   spreizen, auch nicht von jemandem, der schlecht sieht. Eine
   Unbequemlichkeit gegen eine Barriere zu tauschen wäre ein
   schlechter Handel — also werden stattdessen die Felder groß genug.

   Die Sonderfälle am Ende stehen bewusst da: Sie überschreiben
   frühere, spezifischere Regeln (Teilen-Link, Öffentlichkeitsfilter),
   die sonst bei ihren kleinen Werten blieben.

   Das Hochschieben, damit das Feld über der Tastatur liegt, erledigt
   der Browser danach von selbst — das war nie das Problem. */
@media (pointer: coarse) {
  .wl-root input, .wl-root select, .wl-root textarea,
  .wl-root .wl-eingabe, .wl-root .wl-auswahl,
  .wl-teil-link .wl-eingabe, .wl-oefffilter-reihe .wl-auswahl {
    font-size: 16px;
  }
  /* Größere Schrift braucht etwas mehr Luft, sonst wirkt das Feld
     gedrängt. */
  .wl-root .wl-eingabe, .wl-root .wl-auswahl { padding: 10px 11px; }
  /* Fingerbreite Zeilen in der Häkchenliste. */
  .wl-mehrfach-punkt { padding: 11px 14px; font-size: 15px; }
  .wl-mehrfach-punkt input { width: 18px; height: 18px; }
  .wl-mehrfach.ist-kompakt .wl-mehrfach-knopf { font-size: 16px; padding: 10px 11px; }
}


/* Rundum-Etikett: drehbare Flasche auf der Jahrgangsseite */
.wl-etiketten { display: flex; align-items: flex-start; justify-content: flex-end; gap: 18px; flex-wrap: wrap; }
/* ohne Rahmen und eigenen Grund: die Flasche steht auf der Seite */
.wl-rundumklein { position: relative; width: 108px; height: 210px; }
.wl-flaschenmodell:focus-visible { outline: 2px solid var(--granat); outline-offset: 2px; }
.wl-flaschenmodell { display: block; width: 100%; height: 100%; cursor: grab; touch-action: pan-y; }
.wl-flaschenmodell:active { cursor: grabbing; }
.wl-flaschenmodell.ist-gross { width: min(92vw, 560px); height: min(76vh, 760px); touch-action: none; }
.wl-rundumflach { width: 100%; height: 100%; overflow-x: auto; overflow-y: hidden; display: flex; align-items: center; justify-content: center; }
.wl-rundumflach img { display: block; height: 100%; width: auto; max-width: none; }
.wl-rundumflach.ist-gross { width: 92vw; height: 60vh; }
.wl-rundumlupe {
  position: fixed; inset: 0; z-index: 90; background: var(--kreide);
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px;
  animation: wl-einblenden 0.14s ease-out;
}
.wl-rundumlupe .wl-rundumzu { color: var(--tinte); }
.wl-rundumtipp { color: rgba(27, 25, 20, 0.55); font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase; text-align: center; max-width: 560px; padding: 0 16px; line-height: 1.5; }
.wl-rundumzu {
  position: absolute; top: 10px; right: 10px; z-index: 3; width: 40px; height: 40px;
  border: none; background: none; cursor: pointer; color: var(--kreide);
  font-family: var(--sans); font-size: 28px; line-height: 1;
}

/* Rundum-Etikett: Aufnahme im Vollbild */
.wl-rundumaufnahme {
  position: fixed; inset: 0; z-index: 95; display: flex; flex-direction: column;
  background: #12110E; color: var(--kreide); font-family: var(--sans);
}
.wl-rundumbild { position: absolute; inset: 0; overflow: hidden; }
.wl-rundumvideo { display: block; width: 100%; height: 100%; object-fit: cover; }
.wl-rundumumriss { position: absolute; inset: 0; width: 100%; height: 100%; pointer-events: none; }
.wl-rundumkontur {
  fill: rgba(251, 250, 246, 0.06); stroke: rgba(251, 250, 246, 0.92); stroke-width: 2;
  stroke-dasharray: 7 5; vector-effect: non-scaling-stroke;
}
.wl-rundumkontur.ist-blass { opacity: 0.35; }
.wl-rundumkontur.ist-erkannt { fill: none; stroke: #E9C46A; stroke-width: 2.5; stroke-dasharray: none; }
.wl-rundumrechnet { position: absolute; inset: 0; background: rgba(18, 17, 14, 0.7); }
.wl-rundumkopf {
  position: relative; z-index: 2; display: flex; justify-content: space-between; align-items: center;
  padding: calc(10px + env(safe-area-inset-top)) 16px 10px;
  background: linear-gradient(rgba(18, 17, 14, 0.75), rgba(18, 17, 14, 0));
}
.wl-rundumkopf .wl-rundumzu { position: static; }
.wl-rundumtitel { font-family: var(--serif); font-size: 22px; font-weight: 500; }
.wl-rundumfuss {
  position: relative; z-index: 2; margin-top: auto; display: flex; flex-direction: column; gap: 12px;
  padding: 28px 16px calc(16px + env(safe-area-inset-bottom));
  background: linear-gradient(rgba(18, 17, 14, 0), rgba(18, 17, 14, 0.85) 34%);
}
.wl-rundumtext { margin: 0; font-size: 14px; line-height: 1.45; text-align: center; }
.wl-rundumtext.ist-fehler { color: #F4C6C2; }
.wl-rundumformen { display: flex; flex-wrap: wrap; gap: 8px; justify-content: center; }
.wl-rundumaufnahme:not(.ist-pruefen) .wl-appchip { color: rgba(251, 250, 246, 0.85); border-color: rgba(251, 250, 246, 0.4); }
.wl-rundumaufnahme:not(.ist-pruefen) .wl-appchip.ist-aktiv { background: var(--kreide); border-color: var(--kreide); color: var(--tinte); }
.wl-rundumknoepfe { display: flex; justify-content: space-between; gap: 12px; }
.wl-rundumaufnahme:not(.ist-pruefen) .wl-btn--ghost { color: var(--kreide); border-color: rgba(251, 250, 246, 0.45); }
.wl-rundumfortschritt { height: 4px; background: rgba(251, 250, 246, 0.2); overflow: hidden; }
.wl-rundumfortschritt span { display: block; height: 100%; background: var(--kreide); transition: width 0.15s linear; }

/* Rundum-Etikett: Aufnahme aus Fotos */
.wl-rundumfotos {
  position: relative; z-index: 1; flex: 1; min-height: 0; overflow-y: auto;
  display: flex; flex-direction: column; gap: 16px; padding: 4px 16px 8px;
}
.wl-rundumfotos.ist-blass { opacity: 0.45; }
.wl-rundumanleitung { margin: 0; padding-left: 20px; font-size: 14px; line-height: 1.5; color: rgba(251, 250, 246, 0.85); }
.wl-rundumanleitung li + li { margin-top: 4px; }
.wl-rundumfotoliste {
  list-style: none; margin: 0; padding: 0;
  display: grid; grid-template-columns: repeat(auto-fill, minmax(96px, 1fr)); gap: 8px;
}
.wl-rundumfoto { position: relative; aspect-ratio: 3 / 4; background: rgba(251, 250, 246, 0.08); overflow: hidden; }
.wl-rundumfoto img { display: block; width: 100%; height: 100%; object-fit: cover; pointer-events: none; user-select: none; -webkit-user-select: none; }
.wl-rundumfoto.ist-beweglich { cursor: grab; touch-action: none; -webkit-touch-callout: none; user-select: none; -webkit-user-select: none; }
.wl-rundumfoto.ist-beweglich:focus-visible { outline: 2px solid var(--kreide); outline-offset: 2px; }
.wl-rundumfoto.ist-gezogen { z-index: 2; cursor: grabbing; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45); outline: 2px solid var(--kreide); }
/* Foto 1 ist die Vorderseite: Rahmen */
.wl-rundumfoto:first-child::after { content: ""; position: absolute; inset: 0; border: 2px solid var(--kreide); pointer-events: none; }
.wl-nurvorlesen {
  position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden;
  clip-path: inset(50%); white-space: nowrap; border: 0;
}
.wl-rundumfotonr {
  position: absolute; left: 6px; bottom: 6px; min-width: 22px; padding: 1px 6px; text-align: center;
  font-size: 12px; background: rgba(18, 17, 14, 0.7); color: var(--kreide);
}
.wl-rundumfotoweg {
  position: absolute; top: 2px; right: 2px; width: 32px; height: 32px; border: none; cursor: pointer;
  background: rgba(18, 17, 14, 0.6); color: var(--kreide); font-size: 20px; line-height: 1;
}
.wl-rundumfotoknoepfe { display: flex; flex-wrap: wrap; gap: 10px; }
.wl-rundumfotoknoepfe .wl-btn { flex: 1 1 140px; }

/* Rundum-Etikett: Prüfen nach der Aufnahme */
.wl-rundumaufnahme.ist-pruefen { background: var(--kreide); color: var(--tinte); }
.ist-pruefen .wl-rundumkopf { background: none; border-bottom: 1px solid var(--linie); }
.ist-pruefen .wl-rundumzu { color: var(--tinte); }
.wl-rundumpruefen {
  flex: 1; overflow-y: auto; display: flex; flex-wrap: wrap; justify-content: center; align-items: flex-start;
  gap: 20px; padding: 16px;
}
.wl-rundumpruefen .wl-flaschenmodell:not(.ist-gross), .wl-rundumpruefen .wl-rundumflach:not(.ist-gross) { flex: none; width: 210px; height: 44vh; min-height: 260px; max-height: 440px; }
.wl-rundumregler { flex: 1 1 280px; max-width: 440px; display: flex; flex-direction: column; gap: 14px; }
.wl-rundumregler .wl-hinweis { margin: 0; }
.wl-rundumflachvorschau { border: 1px solid var(--linie-stark); line-height: 0; overflow: hidden; }
.wl-rundumflachbild { position: relative; }
.wl-rundumflachbild img { display: block; width: 100%; height: auto; }
.wl-rundumkapsellinie { position: absolute; left: 0; right: 0; height: 0; border-top: 2px solid var(--granat); pointer-events: none; }
.wl-rundumwahl { border: 0; padding: 0; margin: 0; display: flex; flex-wrap: wrap; gap: 8px; }
.wl-rundumwahl legend { padding: 0; margin-bottom: 6px; }
.wl-rundumregler input[type="range"] { width: 100%; accent-color: var(--granat); }
.ist-pruefen .wl-rundumfuss {
  flex-direction: row; justify-content: space-between; padding-top: 12px;
  background: var(--kreide); border-top: 1px solid var(--linie);
}
`;

/* §9 ─ Einstieg ───────────────────────────────────────────────── */

export { CSS };
